
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// 
// index.js
// Cacao
// 
// Created on 7/4/23
// 
// 
// index.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Array.js
// Cacao
// 
// Created on 9/6/22
// 
// 
// Assertions.js
// Cacao
// 
// Created on 9/6/22
// 
function $5868598d1aabdccb$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}


class $e59551ef346ff73a$var$_Array extends Array {
    copy() {
        return this.slice(0);
    }
    append(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        this.push(element);
    }
    appendContentsOf(array) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(array, "`array` is required.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(Array.isArray(array), "`array` needs to be an Array.");
        this.push(...array);
    }
    insertAt(element, index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index >= 0 && index <= this.count, "`index` is out of bounds.");
        this.splice(index, 0, element); // insert `element` at index `index`.
    }
    removeFirst(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        const index = this.indexOf(element);
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeLast() {
        const count = this.count;
        if (count > 0) return this.removeAt(count - 1);
        return undefined;
    }
    removeAt(index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index >= 0 && index < this.count, "`index` is out of bounds.");
        if (index != -1) return this.splice(index, 1)[0];
        return undefined;
    }
    removeAll(whereFn) {
        if (whereFn) {
            const elements = this.filter((element, index)=>!whereFn(element, index));
            this.length = 0;
            this.push(...elements);
        } else this.length = 0;
    }
    swapAt(fromIndex, toIndex) {
        const count = this.count;
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(fromIndex >= 0 && fromIndex < count, "`fromIndex` is out of bounds.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(toIndex >= 0 && toIndex < count, "`toIndex` is out of bounds.");
        if (fromIndex == toIndex) return;
        this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
    }
    contains(element) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(element, "`element` is required.");
        return this.indexOf(element) != -1;
    }
    get isEmpty() {
        return this.length <= 0;
    }
    get first() {
        const count = this.count;
        if (count > 0) return this[0];
        return undefined;
    }
    get last() {
        const count = this.count;
        if (count > 0) return this[count - 1];
        return undefined;
    }
    get count() {
        return this.length;
    }
}
var $e59551ef346ff73a$export$2e2bcd8739ae039 = $e59551ef346ff73a$var$_Array;



// 
// Equivalence.js
// Cacao
// 
// Created on 9/6/22
// 
function $a277ea0f99f667f4$export$2c3070a504066332(a, b) {
    if (a === b) return true;
    if (typeof a != "object" || typeof b != "object" || a == null || b == null) return false;
    let keysA = Object.keys(a), keysB = Object.keys(b);
    if (keysA.length != keysB.length) return false;
    for (let key of keysA){
        if (!keysB.includes(key)) return false;
        if (typeof a[key] === "function" || typeof b[key] === "function") {
            if (a[key].toString() != b[key].toString()) return false;
        } else {
            if (!$a277ea0f99f667f4$export$2c3070a504066332(a[key], b[key])) return false;
        }
    }
    return true;
}


// 
// Logging.js
// Cacao
// 
// Created on 9/6/22
// 
function $bade16267cea3bd0$export$46838187e754e06c(instance) {
    let pointee;
    try {
        pointee = instance.constructor?.name || instance.toString();
    } catch  {
        pointee = "[Unknown]";
    }
    return pointee;
}
function $bade16267cea3bd0$export$4767d4262788a6cc(root, name, children) {
    return new $bade16267cea3bd0$var$TreeGrapher(name, children).parse(root);
}
class $bade16267cea3bd0$var$TreeGrapher {
    constructor(name, children, limit = 1000){
        this.settings = {
            keyword: {
                name: name,
                children: children
            },
            maxLevel: limit
        };
    }
    setPre(level, hasNext, parentPre = "") {
        return `${parentPre}${hasNext ? "\u251C" : "\u2514"}\u{2500}\u{2500} `;
    }
    setTransferPre(parentPre = "", hasNext) {
        return `${parentPre}${hasNext ? "\u2502" : " "}   `;
    }
    parse(tree, level = 0, parentPre = "", treeStr = "") {
        if (!this.check(tree, level)) return "";
        if (Array.isArray(tree)) tree.forEach((child, index)=>{
            const hasNext = tree[index + 1] ? true : false;
            const children = child[this.settings.keyword.children];
            treeStr += `${this.setPre(level, hasNext, parentPre)}${child[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1, this.setTransferPre(parentPre, hasNext));
        });
        else {
            const children = tree[this.settings.keyword.children];
            treeStr = `${tree[this.settings.keyword.name]}\n`;
            if (children) treeStr += this.parse(children, level + 1);
        }
        return treeStr;
    }
    check(tree, level) {
        if (typeof tree !== "object") return false;
        if (level >= this.settings.maxLevel) return false;
        return true;
    }
}




// 
// App.js
// Cacao
// 
// Created on 8/23/22
// 

class $1553bf3484a166d1$var$App {
    #document;
    #readyState;
    #documentHasFinishedLoading = false;
    constructor(document){
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(document, "A container `document` is required to use App.");
        this.#document = document;
        this.#attach();
    }
    documentReadyStateDidChange(document) {
    // Override if needed.
    }
    documentDidLoad(document) {
    // Override if needed.
    }
    #attach() {
        const document = this.#document;
        const handleDocumentState = ()=>{
            if (this.#readyState != document.readyState) {
                this.#readyState = document.readyState;
                this.documentReadyStateDidChange(document);
            }
            switch(document.readyState){
                case "loaded":
                case "complete":
                case "interactive":
                    // The document has finished loading. We can now access the DOM elements.
                    if (!this.#documentHasFinishedLoading) {
                        this.#documentHasFinishedLoading = true;
                        this.documentDidLoad(document);
                    }
                    break;
            }
        };
        handleDocumentState();
        if (!this.#documentHasFinishedLoading) document.addEventListener("readystatechange", handleDocumentState);
    }
    get document() {
        return this.#document;
    }
}
var $1553bf3484a166d1$export$2e2bcd8739ae039 = $1553bf3484a166d1$var$App;


// 
// View.js
// Cacao
// 
// Created on 8/23/22
// 

class $75862b29e2b1753f$var$View {
    #node;
    #subviews = new (0, $e59551ef346ff73a$export$2e2bcd8739ae039)();
    #superview;
    #isNodeLoaded = false;
    constructor(){
    //
    }
    makeNode(document1) {
        return document1.createElement("div");
    }
    addSubview(subview1) {
        this.insertSubview(subview1, this.#subviews.length);
    }
    insertSubviewBelow(subview1, siblingSubview) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 !== siblingSubview, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a sibling that is the same view.`);
        this.insertSubview(subview1, this.#subviews.indexOf(siblingSubview));
    }
    insertSubviewAbove(subview1, siblingSubview) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 !== siblingSubview, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a sibling that is the same view.`);
        this.insertSubview(subview1, this.#subviews.indexOf(siblingSubview) + 1);
    }
    insertSubview(subview1, index) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1, `Attempted to insert undefined subview at index ${index}`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 instanceof $75862b29e2b1753f$var$View, `Attempted to insert invalid subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" at index ${index}" that's not a View.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1 != this, `Attempted to insert view "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" as a subview of itself.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)((index)=>0, `Attempted to insert subview "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}" at invalid index ${index}"`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(index != -1, "Index cannot be -1.");
        if (subview1.superview !== this) subview1.removeFromSuperview();
        try {
            const { node: node } = this;
            const { childNodes: childNodes } = node;
            if (index >= childNodes.length) node.appendChild(subview1.node);
            else node.insertBefore(subview1.node, childNodes[index].node);
        } catch (error) {
            throw new Error(`Couldn't perform DOM hierarchy change when inserting view "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview1)}". Document may be in an inconsistent state.`, {
                cause: error
            });
        }
        this.#subviews.insertAt(subview1, index);
        subview1.#superview = this;
    }
    removeFromSuperview() {
        const { superview: superview } = this;
        if (superview) {
            superview.#removeSubview(this);
            return;
        }
        if (this.isNodeLoaded) {
            const { node: node } = this;
            const { parentNode: parentNode } = node;
            if (parentNode) parentNode.removeChild(node);
        }
    }
    isDescendantOfView(view) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(view, `The view to test against the receiver cannot be undefined.`);
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview instanceof $75862b29e2b1753f$var$View, `The view to test against the receiver "${(0, $bade16267cea3bd0$export$46838187e754e06c)(subview)}" is not a View.`);
        const visit = (viewToTest)=>{
            if (viewToTest == view) return true;
            const parent = viewToTest.superview;
            return parent ? visit(parent) : false;
        };
        return visit(this);
    }
    #removeSubview(subview1) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(subview1, "Subview is required.");
        this.#subviews.removeFirst(subview1);
        if (subview1.isNodeLoaded) subview1.node.remove();
    }
    // Node
    makeNodeIfNeeded() {
        if (this.#isNodeLoaded) return;
        // TODO: Support passing custom `document` instance, shadow DOM?
        let node;
        try {
            node = this.makeNode(document);
        } catch  {
            throw new Error("A DOM node couldn't be materialized for this View.");
        }
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(node, "The result of -makeNode() must return a DOM node for this View.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(node instanceof Node, "A DOM node must be an instance of Node.");
        this.#node = node;
        this.#isNodeLoaded = true;
    }
    // Getters
    get isNodeLoaded() {
        return this.#isNodeLoaded;
    }
    get node() {
        this.makeNodeIfNeeded();
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(this.#node, "The node shouldn't be undefined at this point.");
        return this.#node;
    }
    get subviews() {
        return this.#subviews.copy();
    }
    get superview() {
        return this.#superview;
    }
}
var $75862b29e2b1753f$export$2e2bcd8739ae039 = $75862b29e2b1753f$var$View;


// 
// RootView.js
// Cacao
// 
// Created on 8/23/22
// 


class $7f8792a5bdbc7afc$var$RootView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    #container;
    constructor(container){
        super();
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(container, "A `container` is required.");
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(container instanceof HTMLElement, "`container` is not an HTMLElement.");
        this.#container = container;
        this.attach();
    }
    get container() {
        return this.#container;
    }
    attach() {
        try {
            this.#container.appendChild(this.node);
        } catch  {
            throw new Error(`Failed to connect RootView to container.`);
        }
    }
    detach() {
        const parent = this.node.parent;
        if (parent) parent.removeChild(this.node);
    }
}
var $7f8792a5bdbc7afc$export$2e2bcd8739ae039 = $7f8792a5bdbc7afc$var$RootView;


// 
// Canvas2DView.js
// Cacao
// 
// Created on 9/8/22
// 

// 
// index.js
// Cacao
// 
// Created on 7/4/23
// 
// 
// Geometry.js
// Cacao
// 
// Created on 9/8/22
// 
class $cba996667aa58736$export$c79fc6492f3af13d {
    origin = $cba996667aa58736$export$baf26146a414f24a.zero;
    size = $cba996667aa58736$export$cb6da89c6af1a8ec.zero;
    static make(x, y, width, height) {
        return new $cba996667aa58736$export$c79fc6492f3af13d(new $cba996667aa58736$export$baf26146a414f24a(x, y), new $cba996667aa58736$export$cb6da89c6af1a8ec(width, height));
    }
    static from(rect) {
        if (!rect) return undefined;
        return $cba996667aa58736$export$c79fc6492f3af13d.make(rect.origin.x, rect.origin.y, rect.size.width, rect.size.height);
    }
    static fromDOMRect(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return $cba996667aa58736$export$c79fc6492f3af13d.make(x, y, width, height);
    }
    static get zero() {
        return $cba996667aa58736$export$c79fc6492f3af13d.make(0, 0, 0, 0);
    }
    static get null() {
        return $cba996667aa58736$export$c79fc6492f3af13d.make(Infinity, Infinity, 0, 0);
    }
    constructor(origin, size){
        this.origin = $cba996667aa58736$export$baf26146a414f24a.from(origin);
        this.size = $cba996667aa58736$export$cb6da89c6af1a8ec.from(size);
    }
    equals(rect) {
        rect = $cba996667aa58736$export$c79fc6492f3af13d.from(rect);
        return this.origin.x == rect.origin.x && this.origin.y == rect.origin.y && this.size.width == rect.size.width && this.size.height == rect.size.height;
    }
    copy() {
        return $cba996667aa58736$export$c79fc6492f3af13d.make(this.origin.x, this.origin.y, this.size.width, this.size.height);
    }
    offsetBy(dx, dy) {
        return $cba996667aa58736$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width, this.size.height);
    }
    insetBy(dx, dy) {
        return $cba996667aa58736$export$c79fc6492f3af13d.make(this.origin.x + dx, this.origin.y + dy, this.size.width - 2 * dx, this.size.height - 2 * dy);
    }
    insetByEdgeInsets(edgeInsets) {
        edgeInsets = $cba996667aa58736$export$45cce0bd6c1f342a.from(edgeInsets);
        return $cba996667aa58736$export$c79fc6492f3af13d.make(this.origin.x + edgeInsets.left, this.origin.y + edgeInsets.top, this.size.width - edgeInsets.left - edgeInsets.right, this.size.height - edgeInsets.top - edgeInsets.bottom);
    }
    divide(slice, remainder, amount, edge) {
        slice.origin = this.origin.copy();
        slice.size = this.size.copy();
        remainder.origin = this.origin.copy();
        remainder.size = this.size.copy();
        switch(edge){
            case $cba996667aa58736$export$b9d9805c9b77a56d.minX:
                slice.size.width = amount;
                remainder.origin.x += amount;
                remainder.size.width -= amount;
                break;
            case $cba996667aa58736$export$b9d9805c9b77a56d.maxX:
                slice.origin.x = $cba996667aa58736$export$c79fc6492f3af13d.from(slice).maxX - amount;
                slice.size.width = amount;
                remainder.size.width -= amount;
                break;
            case $cba996667aa58736$export$b9d9805c9b77a56d.minY:
                slice.size.height = amount;
                remainder.origin.y += amount;
                remainder.size.height -= amount;
                break;
            case $cba996667aa58736$export$b9d9805c9b77a56d.maxY:
                slice.origin.y = $cba996667aa58736$export$c79fc6492f3af13d.from(slice).maxY - amount;
                slice.size.height = amount;
                remainder.size.height -= amount;
                break;
        }
    }
    containsPoint(aPoint) {
        return aPoint.x >= this.origin.x && aPoint.y >= this.origin.y && aPoint.x < this.maxX && aPoint.y < this.maxY;
    }
    containsRect(rect) {
        const union = this.union(rect);
        return this.equals(union);
    }
    intersects(rect) {
        const intersection = this.intersection(rect);
        return !intersection.isEmpty;
    }
    intersection(rect) {
        rect = $cba996667aa58736$export$c79fc6492f3af13d.from(rect);
        const intersection = $cba996667aa58736$export$c79fc6492f3af13d.make(Math.max(this.minX, rect.minX), Math.max(this.minY, rect.minY), 0, 0);
        intersection.size.width = Math.min(this.maxX, rect.maxX) - intersection.minX;
        intersection.size.height = Math.min(this.maxY, rect.maxY) - intersection.minY;
        return intersection.isEmpty ? $cba996667aa58736$export$c79fc6492f3af13d.zero : intersection;
    }
    union(rect) {
        rect = $cba996667aa58736$export$c79fc6492f3af13d.from(rect);
        const thisIsNull = this.isNull, rectIsNull = !rect || rect.isNull;
        if (thisIsNull) return rectIsNull ? $cba996667aa58736$export$c79fc6492f3af13d.null : rect;
        if (rectIsNull) return thisIsNull ? $cba996667aa58736$export$c79fc6492f3af13d.null : this.copy();
        const minX = Math.min(this.minX, rect.minX), minY = Math.min(this.minY, rect.minY), maxX = Math.max(this.maxX, rect.maxX), maxY = Math.max(this.maxY, rect.maxY);
        return $cba996667aa58736$export$c79fc6492f3af13d.make(minX, minY, maxX - minX, maxY - minY);
    }
    get standarized() {
        const { width: width, height: height } = this;
        const standardized = this.copy();
        if (width < 0.0) {
            standardized.origin.x += width;
            standardized.size.width = -width;
        }
        if (height < 0.0) {
            standardized.origin.y += height;
            standardized.size.height = -height;
        }
        return standardized;
    }
    get integral() {
        const rect = this.standarized;
        const x = Math.floor(this.minX), y = Math.floor(this.minY);
        aRect.size.width = Math.ceil(this.maxX) - x;
        aRect.size.height = Math.ceil(this.maxY) - y;
        aRect.origin.x = x;
        aRect.origin.y = y;
        return aRect;
    }
    get width() {
        return this.size.width;
    }
    set width(width) {
        this.size.width = width;
    }
    get height() {
        return this.size.height;
    }
    set height(height) {
        this.size.height = height;
    }
    get x() {
        return this.origin.x;
    }
    set x(x) {
        this.origin.x = x;
    }
    get y() {
        return this.origin.y;
    }
    set y(y) {
        this.origin.y = y;
    }
    get maxX() {
        return this.origin.x + this.size.width;
    }
    get maxY() {
        return this.origin.y + this.size.height;
    }
    get midX() {
        return this.origin.x + this.size.width / 2.0;
    }
    get midY() {
        return this.origin.y + this.size.height / 2.0;
    }
    get minX() {
        return this.origin.x;
    }
    get minY() {
        return this.origin.y;
    }
    get isEmpty() {
        return this.size.width <= 0.0 || this.size.height <= 0.0 || this.origin.x === Infinity || this.origin.y === Infinity;
    }
    get isNull() {
        return this.origin.x === Infinity || this.origin.y === Infinity;
    }
    toString() {
        return `{${this.origin}, ${this.size}}`;
    }
    toDOMRect() {
        const { x: x, y: y, width: width, height: height } = this;
        return new DOMRect(x, y, width, height);
    }
}
class $cba996667aa58736$export$baf26146a414f24a {
    x = 0;
    y = 0;
    static get zero() {
        return new $cba996667aa58736$export$baf26146a414f24a(0, 0);
    }
    static from(point) {
        return !point ? $cba996667aa58736$export$baf26146a414f24a.zero : $cba996667aa58736$export$baf26146a414f24a.make(point.x, point.y);
    }
    static make(x, y) {
        return new $cba996667aa58736$export$baf26146a414f24a(x, y);
    }
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    equals(point) {
        return this.x == point.x && this.y == point.y;
    }
    copy() {
        return new $cba996667aa58736$export$baf26146a414f24a(this.x, this.y);
    }
    toString() {
        return `{${this.x}, ${this.y}}`;
    }
}
class $cba996667aa58736$export$cb6da89c6af1a8ec {
    width = 0;
    height = 0;
    static get zero() {
        return new $cba996667aa58736$export$cb6da89c6af1a8ec(0, 0);
    }
    static from(size) {
        return !size ? undefined : $cba996667aa58736$export$cb6da89c6af1a8ec.make(size.width, size.height);
    }
    static make(width, height) {
        return new $cba996667aa58736$export$cb6da89c6af1a8ec(width, height);
    }
    constructor(width, height){
        this.width = width;
        this.height = height;
    }
    equals(size) {
        return this.width == size.width && this.height == size.height;
    }
    copy() {
        return new $cba996667aa58736$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    toString() {
        return `{${this.width}, ${this.height}}`;
    }
}
class $cba996667aa58736$export$b9d9805c9b77a56d {
    static minX() {
        return 0;
    }
    static minY() {
        return 1;
    }
    static maxX() {
        return 2;
    }
    static maxY() {
        return 3;
    }
}
class $cba996667aa58736$export$45cce0bd6c1f342a {
    top = 0;
    left = 0;
    bottom = 0;
    right = 0;
    static get zero() {
        return new $cba996667aa58736$export$45cce0bd6c1f342a(0, 0, 0, 0);
    }
    static from(edgeInsets) {
        return !edgeInsets ? undefined : $cba996667aa58736$export$45cce0bd6c1f342a.make(edgeInsets.top, edgeInsets.left, edgeInsets.bottom, edgeInsets.right);
    }
    static make(top, left, bottom, right) {
        return new $cba996667aa58736$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
    constructor(top = 0, left = 0, bottom = 0, right = 0){
        this.top = top;
        this.left = left;
        this.bottom = bottom;
        this.right = right;
    }
    equals(edgeInsets) {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return top == edgeInsets.top && left == edgeInsets.left && bottom == edgeInsets.bottom && right == edgeInsets.right;
    }
    copy() {
        const { top: top, left: left, bottom: bottom, right: right } = this;
        return new $cba996667aa58736$export$45cce0bd6c1f342a(top, left, bottom, right);
    }
}


// 
// Interpolation.js
// Cacao
// 
// Created on 6/8/23
// 
function $fb82d837ae8af290$var$lerp(x, y, a) {
    return x * (1 - a) + y * a;
}
function $fb82d837ae8af290$var$clamp(a, min = 0, max = 1) {
    return Math.min(max, Math.max(min, a));
}
function $fb82d837ae8af290$var$invlerp(a, b, value) {
    return (value - a) / (b - a);
}
function $fb82d837ae8af290$var$range(x1, y1, x2, y2, a) {
    return $fb82d837ae8af290$var$lerp(x2, y2, $fb82d837ae8af290$var$invlerp(x1, y1, a));
}
var $fb82d837ae8af290$export$2e2bcd8739ae039 = {
    lerp: $fb82d837ae8af290$var$lerp,
    clamp: $fb82d837ae8af290$var$clamp,
    range: $fb82d837ae8af290$var$range,
    invlerp: $fb82d837ae8af290$var$invlerp
};


// 
// RubberBanding.js
// Cacao
// 
// Created on 5/8/23
// 
function $4e96105970bc8553$var$clampedValueUsingRubberBandingParameters(value, parameters) {
    const { coeff: coeff = 0.55, dim: dim } = parameters;
    return (1.0 - 1.0 / (value * coeff / dim + 1.0)) * dim;
}
var $4e96105970bc8553$export$2e2bcd8739ae039 = {
    clamp: $4e96105970bc8553$var$clampedValueUsingRubberBandingParameters
};


// 
// Path2D.js
// Cacao
// 
// Created on 9/9/22
// 

class $3a254293879eb821$var$_Path2D extends Path2D {
    roundedRect(x, y, width, height, cornerRadius, roundedCornerStyle) {
        const rect = (0, $cba996667aa58736$export$c79fc6492f3af13d).make(x, y, width, height);
        const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = rect;
        switch(roundedCornerStyle){
            case "continous":
                const limit = Math.min(width, height) / 2 / 1.52866483;
                const limitedRadius = Math.min(cornerRadius, limit);
                const TOP_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        minY + y * limitedRadius
                    ];
                };
                const TOP_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        minX + y * limitedRadius
                    ];
                };
                const BOTTOM_RIGHT = (x, y)=>{
                    return [
                        maxX - x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const BOTTOM_LEFT = (x, y)=>{
                    return [
                        minX + x * limitedRadius,
                        maxY - y * limitedRadius
                    ];
                };
                const { moveTo: moveTo, lineTo: lineTo, bezierCurveTo: bezierCurveTo } = this;
                moveTo.apply(this, TOP_LEFT(1.52866483, 0.00000000));
                lineTo.apply(this, TOP_RIGHT(1.52866471, 0.00000000));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(1.08849323, 0.00000000), TOP_RIGHT(0.86840689, 0.00000000), TOP_RIGHT(0.66993427, 0.06549600)));
                lineTo.apply(this, TOP_RIGHT(0.63149399, 0.07491100));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.37282392, 0.16905899), TOP_RIGHT(0.16906013, 0.37282401), TOP_RIGHT(0.07491176, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(TOP_RIGHT(0.00000000, 0.86840701), TOP_RIGHT(0.00000000, 1.08849299), TOP_RIGHT(0.00000000, 1.52866483)));
                lineTo.apply(this, BOTTOM_RIGHT(0.00000000, 1.52866471));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.00000000, 1.08849323), BOTTOM_RIGHT(0.00000000, 0.86840689), BOTTOM_RIGHT(0.06549569, 0.66993493)));
                lineTo.apply(this, BOTTOM_RIGHT(0.07491111, 0.63149399));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.16905883, 0.37282392), BOTTOM_RIGHT(0.37282392, 0.16905883), BOTTOM_RIGHT(0.63149399, 0.07491111)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_RIGHT(0.86840689, 0.00000000), BOTTOM_RIGHT(1.08849323, 0.00000000), BOTTOM_RIGHT(1.52866471, 0.00000000)));
                lineTo.apply(this, BOTTOM_LEFT(1.52866483, 0.00000000));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(1.08849299, 0.00000000), BOTTOM_LEFT(0.86840701, 0.00000000), BOTTOM_LEFT(0.66993397, 0.06549569)));
                lineTo.apply(this, BOTTOM_LEFT(0.63149399, 0.07491111));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.37282401, 0.16905883), BOTTOM_LEFT(0.16906001, 0.37282392), BOTTOM_LEFT(0.07491100, 0.63149399)));
                bezierCurveTo.apply(this, [].concat(BOTTOM_LEFT(0.00000000, 0.86840689), BOTTOM_LEFT(0.00000000, 1.08849323), BOTTOM_LEFT(0.00000000, 1.52866471)));
                lineTo.apply(this, TOP_LEFT(0.00000000, 1.52866483));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.00000000, 1.08849299), TOP_LEFT(0.00000000, 0.86840701), TOP_LEFT(0.06549600, 0.66993397)));
                lineTo.apply(this, TOP_LEFT(0.07491100, 0.63149399));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.16906001, 0.37282401), TOP_LEFT(0.37282401, 0.16906001), TOP_LEFT(0.63149399, 0.07491100)));
                bezierCurveTo.apply(this, [].concat(TOP_LEFT(0.86840701, 0.00000000), TOP_LEFT(1.08849299, 0.00000000), TOP_LEFT(1.52866483, 0.00000000)));
                break;
            default:
                if (width < 2 * cornerRadius) cornerRadius = width / 2;
                if (height < 2 * cornerRadius) cornerRadius = height / 2;
                this.moveTo(x + cornerRadius, minY);
                this.arcTo(maxX, minY, maxX, maxY, cornerRadius);
                this.arcTo(maxX, maxY, minX, maxY, cornerRadius);
                this.arcTo(minX, maxY, minX, minY, cornerRadius);
                this.arcTo(minX, minY, maxX, minY, cornerRadius);
                break;
        }
        this.closePath();
    }
}
var $3a254293879eb821$export$2e2bcd8739ae039 = $3a254293879eb821$var$_Path2D;





class $9d9c9f916c716294$var$Canvas2DView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    #options = {
        width: 1,
        height: 1,
        scale: 0
    };
    #dirtyRect;
    #displayRequestID;
    makeNode(document) {
        return document.createElement("canvas");
    }
    drawRect(rect) {
    // override to render
    }
    setNeedsDisplay() {
        this.#dirtyRect = (0, $cba996667aa58736$export$c79fc6492f3af13d).null;
        this.#scheduleDisplay();
    }
    setNeedsDisplayInRect(rect) {
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(rect, "A rect must be passed.");
        rect = (0, $cba996667aa58736$export$c79fc6492f3af13d).from(rect);
        this.#dirtyRect = this.#dirtyRect?.union(rect) || rect;
        this.#scheduleDisplay();
    }
    #scheduleDisplay() {
        const view = this;
        if (this.#displayRequestID) return;
        this.#displayRequestID = window.requestAnimationFrame(function BROWSER_IS_CALLING_OUT_TO_CANVAS2DVIEW_REQUEST_ANIMATION_FRAME_CALLBACK() {
            view.#displayRequestID = undefined;
            view.#display();
        });
    }
    #display() {
        const { node: node, options: options, context: context } = this;
        const { width: width, height: height, scale: scale } = options;
        const bounds = (0, $cba996667aa58736$export$c79fc6492f3af13d).make(0, 0, width, height);
        // Scale context:
        const scaled = scale != 1;
        if (scaled) {
            context.save();
            context.scale(scale, scale);
        }
        // Calculate dirty rect. If rect is null, refresh the entire bounds of the canvas:
        let dirtyRect = this.#dirtyRect?.copy();
        if (!dirtyRect || dirtyRect.isNull) dirtyRect = bounds;
        // Intersect so we don't draw outside of bounds:
        dirtyRect = bounds.intersection(dirtyRect);
        // Clear entire bounds if `dirtyRect` is actually the whole view.
        // Maybe this should be a property.
        if (dirtyRect.equals(bounds)) context.clearRect(0, 0, width, height);
        // Call drawRect():
        this.drawRect(dirtyRect);
        // Restore context:
        if (scaled) context.restore();
        this.#dirtyRect = undefined;
    }
    set options(options) {
        let { width: width, height: height, scale: scale } = options;
        (0, $5868598d1aabdccb$export$a7a9523472993e97)(width && height, "`width` and `height` are required options.");
        if (!scale || scale <= 0.01) scale = window.devicePixelRatio;
        this.#options = {
            width: width,
            height: height,
            scale: scale
        };
        const { node: node } = this;
        node.width = width * scale;
        node.height = height * scale;
        node.style.width = `${width}px`;
        node.style.height = `${height}px`;
        this.setNeedsDisplay();
    }
    get options() {
        const { width: width, height: height, scale: scale } = this.#options;
        return {
            width: width,
            height: height,
            scale: scale
        };
    }
    get context() {
        return this.node.getContext("2d");
    }
}
var $9d9c9f916c716294$export$2e2bcd8739ae039 = $9d9c9f916c716294$var$Canvas2DView;


// 
// index.js
// Cacao
// 
// Created on 7/6/23
// 
// 
// GestureRecognizer.js
// Cacao
// 
// Created on 6/2/23
// 
// 
// Touch.js
// Cacao
// 
// Created on 5/8/23
// 
class $7a418fcf08526eb7$var$Touch {
    constructor(){
        this.x = 0;
        this.y = 0;
        this.tapCount = 0;
    }
}
var $7a418fcf08526eb7$export$2e2bcd8739ae039 = $7a418fcf08526eb7$var$Touch;


// 
// TouchType.js
// Cacao
// 
// Created on 6/17/23
// 
class $f83981078758ac76$var$TouchType {
    static direct = 0;
    static indirect = 1;
    static pen = 2;
}
var $f83981078758ac76$export$2e2bcd8739ae039 = $f83981078758ac76$var$TouchType;


// 
// GestureRecognizerState.js
// Cacao
// 
// Created on 6/2/23
// 
class $0d409e98add6de65$var$GestureRecognizerState {
    static possible = 0;
    static began = 1;
    static changed = 2;
    static ended = 3;
    static cancelled = 4;
    static failed = 5;
    static recognized = $0d409e98add6de65$var$GestureRecognizerState.ended;
}
var $0d409e98add6de65$export$2e2bcd8739ae039 = $0d409e98add6de65$var$GestureRecognizerState;


class $d835ab54782b41e2$var$GestureRecognizer {
    enabled;
    didChange;
    shouldBegin;
    constructor(){
        this._state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible;
        this._touches = [];
        this.enabled = true;
    }
    reset() {
        this._state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible;
        this._event = undefined;
    }
    set state(state) {
        if (this.shouldBegin && this._state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible && (state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).recognized || state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began)) {
            if (!this.shouldBegin(this)) state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed;
        }
        const allowedStateTransitions = [
            // Discrete gestures:
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).recognized,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed,
                false
            ],
            // Continuous gestures:
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).began,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled,
                true
            ],
            [
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed,
                (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended,
                true
            ]
        ];
        let transition;
        for (const [fromState, toState, notify] of allowedStateTransitions)if (fromState == this._state && toState == state) {
            transition = {
                fromState: fromState,
                toState: toState,
                notify: notify
            };
            break;
        }
        if (!transition) throw new Error(`GestureRecognizer: Invalid state transition from ${this._state} to ${state}.`);
        if (transition) {
            this._state = state;
            if (transition.notify && this.didChange) this.didChange(this);
        }
    }
    get state() {
        return this._state;
    }
    get event() {
        return this._event;
    }
    began(touches, event) {
    //
    }
    moved(touches, event) {
    //
    }
    ended(touches, event) {
    //
    }
    cancelled(touches, event) {
    //
    }
    handleEvent(event) {
        // For now, only single-touch (and mouse) events are supported:
        if (!event.isPrimary) return;
        this._event = event;
        const touch = new (0, $7a418fcf08526eb7$export$2e2bcd8739ae039)();
        touch.identifier = event.pointerId;
        touch.x = event.clientX;
        touch.y = event.clientY;
        touch.tapCount = 1; // TODO
        if (event.pointerType) switch(event.pointerType){
            case "mouse":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
                break;
            case "pen":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).pen;
                break;
            case "touch":
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).direct;
                break;
            default:
                touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
                break;
        }
        else touch.type = (0, $f83981078758ac76$export$2e2bcd8739ae039).indirect;
        if (event.type == "pointerdown") {
            const continueTrackingOnWindow = true; // Expose this behavior?
            const target = continueTrackingOnWindow ? window : event.currentTarget;
            target.addEventListener("pointermove", this);
            target.addEventListener("pointerup", this);
            target.addEventListener("pointercancel", this);
            this._currentTarget = target;
        }
        const touches = [
            touch
        ];
        this._touches = touches;
        // Deliver touches if the gesture has not yet failed.
        if (this.state != (0, $0d409e98add6de65$export$2e2bcd8739ae039).failed) switch(event.type){
            case "pointerdown":
                this.began(touches, event);
                break;
            case "pointermove":
                this.moved(touches, event);
                break;
            case "pointerup":
                this.ended(touches, event);
                break;
            case "pointercancel":
                this.cancelled(touches, event);
                break;
        }
        switch(event.type){
            case "pointerup":
            case "pointercancel":
                const target = this._currentTarget;
                target.removeEventListener("pointermove", this);
                target.removeEventListener("pointerup", this);
                target.removeEventListener("pointercancel", this);
                this.reset();
                break;
        }
    }
    attach(target) {
        target.addEventListener("pointerdown", this);
    }
    locationInView(view) {
        // TODO: Convert to view coordinates.
        const touch = this._touches[0];
        if (touch) {
            const { x: x, y: y } = touch;
            return {
                x: x,
                y: y
            };
        }
        return undefined;
    }
    touchesInView(view) {
        // TODO: Return touches for the view.
        return this._touches.slice(0);
    }
    canPreventGestureRecognizer(preventingGestureRecognizer) {
        return true;
    }
    canBePreventedByGestureRecognizer(preventedGestureRecognizer) {
        return true;
    }
}
var $d835ab54782b41e2$export$2e2bcd8739ae039 = $d835ab54782b41e2$var$GestureRecognizer;



// 
// PanGestureRecognizer.js
// Cacao
// 
// Created on 5/8/23
// 


class $e0ae29d71a91a327$var$PanGestureRecognizer extends (0, $d835ab54782b41e2$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._touchesSamplingQueue = [];
    }
    set translation(value) {
        this._initialTouchPosition = value;
        this._latestTouchPosition = value;
    }
    get translation() {
        let x = 0, y = 0;
        const initial = this._initialTouchPosition, latest = this._latestTouchPosition;
        if (initial && latest) {
            x = latest.x - initial.x;
            y = latest.y - initial.y;
        }
        return {
            x: x,
            y: y
        };
    }
    get velocity() {
        this.dequeueSampledTouchesBeforeInterval(1000);
        const queue = this._touchesSamplingQueue;
        if (queue.length < 2) return {
            x: 0,
            y: 0
        };
        const first = queue[0], last = queue[queue.length - 1];
        const distance = {
            x: last.position.x - first.position.x,
            y: last.position.y - first.position.y
        };
        const time = (last.time - first.time) / 1000;
        return {
            x: distance.x / time,
            y: distance.y / time
        };
    }
    // - Sampling touches
    addSampleForTouchPosition(position) {
        this._touchesSamplingQueue.push({
            position: position,
            time: Date.now()
        });
        this.dequeueSampledTouchesBeforeInterval(50);
    }
    dequeueSampledTouchesBeforeInterval(duration) {
        const queue = this._touchesSamplingQueue;
        const expiration = Date.now() - duration;
        while(queue.length && queue[0].time < expiration)queue.shift();
    }
    updateLatestTouchPosition(position, event) {
        position = {
            x: position.x,
            y: position.y
        };
        this._latestTouchPosition = position;
        this.addSampleForTouchPosition(position);
    }
    // - State overrides
    reset() {
        super.reset();
        this._latestTouchPosition = undefined;
        this._initialTouchPosition = undefined;
        this._touchesSamplingQueue.splice(0);
    }
    began(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible) {
            this._initialTouchPosition = {
                x: touches[0].x,
                y: touches[0].y
            };
            this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).began;
        }
    }
    moved(touches, event) {
        this.updateLatestTouchPosition(touches[0], event);
        this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed;
    }
    ended(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) {
            this.updateLatestTouchPosition(touches[0], event);
            this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended;
        }
    }
    cancelled(touches, event) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
}
var $e0ae29d71a91a327$export$2e2bcd8739ae039 = $e0ae29d71a91a327$var$PanGestureRecognizer;


// 
// TapGestureRecognizer.js
// Cacao
// 
// Created on 6/8/23
// 


class $890fe1ec12e520f9$var$TapGestureRecognizer extends (0, $d835ab54782b41e2$export$2e2bcd8739ae039) {
    numberOfTapsRequired = 1;
    numberOfTouchesRequired = 1;
    canPreventGestureRecognizer(preventingGestureRecognizer) {
        if (preventingGestureRecognizer instanceof $890fe1ec12e520f9$var$TapGestureRecognizer) return preventingGestureRecognizer.numberOfTapsRequired > this.numberOfTapsRequired;
        else return super.canPreventGestureRecognizer(preventingGestureRecognizer);
    }
    canBePreventedByGestureRecognizer(preventedGestureRecognizer) {
        if (preventedGestureRecognizer instanceof $890fe1ec12e520f9$var$TapGestureRecognizer) return preventedGestureRecognizer.numberOfTapsRequired <= this.numberOfTapsRequired;
        else return super.canBePreventedByGestureRecognizer(preventedGestureRecognizer);
    }
    began(touches) {
        const touch = touches[0];
        if (touch.tapCount >= this.numberOfTapsRequired) {
            if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).possible) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).began;
            else if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed;
        }
    }
    moved(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
    ended(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).ended;
    }
    cancelled(touches) {
        if (this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).began || this.state == (0, $0d409e98add6de65$export$2e2bcd8739ae039).changed) this.state = (0, $0d409e98add6de65$export$2e2bcd8739ae039).cancelled;
    }
}
var $890fe1ec12e520f9$export$2e2bcd8739ae039 = $890fe1ec12e520f9$var$TapGestureRecognizer;






// 
// index.js
// Cacao
// 
// Created on 7/6/23
// 
// 
// AnimatedProperty.js
// Cacao
// 
// Created on 5/8/23
// 
class $ff409bc474e7092d$var$AnimatedProperty {
    constructor(key, fromValue, toValue, timing){
        if (!key) throw "AnimatedProperty: Cannot animate a property without a key.";
        const f = this.parseValue(fromValue), t = this.parseValue(toValue);
        if (!t.unit) t.unit = f.unit; // assume `fromValue` unit if not present.
        if (!(!f.unit && !t.unit || f.unit === t.unit)) throw `AnimatedProperty: Unit for values mismatch. Animating from "${f.unit}" to "${t.unit}" is not supported.`;
        this.fromValue = f.floatValue;
        this.toValue = t.floatValue;
        this.unit = f.unit;
        this.key = key;
        this.timing = timing;
    }
    parseValue(value) {
        let floatValue = 0.0, unit = undefined;
        if (typeof value === "string" || value instanceof String) {
            floatValue = parseFloat(value);
            unit = value.match(/[\d.\-\+]*\s*(.*)/)[1] || "";
        } else if (!isNaN(value)) floatValue = value;
        return {
            unit: unit,
            floatValue: floatValue
        };
    }
    get reversed() {
        return new $ff409bc474e7092d$var$AnimatedProperty(this.key, this.toValue, this.fromValue, this.timing);
    }
}
var $ff409bc474e7092d$export$2e2bcd8739ae039 = $ff409bc474e7092d$var$AnimatedProperty;


// 
// PropertyAnimator.js
// Cacao
// 
// Created on 5/4/23
// 


// 
// SpringTimingParameters.js
// Cacao
// 
// Created on 5/8/23
// 
const { sqrt: $eb4fc4a00fc6fb7d$var$sqrt, exp: $eb4fc4a00fc6fb7d$var$exp, cos: $eb4fc4a00fc6fb7d$var$cos, sin: $eb4fc4a00fc6fb7d$var$sin, cosh: $eb4fc4a00fc6fb7d$var$cosh, sinh: $eb4fc4a00fc6fb7d$var$sinh } = Math;
class $eb4fc4a00fc6fb7d$var$SpringTimingParameters {
    constructor(options = {}){
        const { damping: damping = 10, mass: mass = 1, stiffness: stiffness = 100, initialVelocity: initialVelocity = {
            dx: 0,
            dy: 0
        } } = options;
        this.damping = damping;
        this.mass = mass;
        this.stiffness = stiffness;
        this.initialVelocity = initialVelocity;
    }
    copy() {
        const { damping: damping, mass: mass, stiffness: stiffness, initialVelocity: initialVelocity } = this;
        return new $eb4fc4a00fc6fb7d$var$SpringTimingParameters({
            damping: damping,
            mass: mass,
            stiffness: stiffness,
            initialVelocity: initialVelocity
        });
    }
    copyTimingFunction(options = {}) {
        const { damping: b, mass: m, stiffness: k } = this;
        const v0 = this.#initialVelocityForVelocityAxis(options.velocityAxis);
        return (t)=>{
            const beta = b / (2.0 * m);
            const omega0 = $eb4fc4a00fc6fb7d$var$sqrt(k / m);
            const omega1 = $eb4fc4a00fc6fb7d$var$sqrt(omega0 * omega0 - beta * beta);
            const omega2 = $eb4fc4a00fc6fb7d$var$sqrt(beta * beta - omega0 * omega0);
            const x0 = -1;
            const envelope = $eb4fc4a00fc6fb7d$var$exp(-beta * t);
            let fraction;
            if (beta < omega0) fraction = -x0 + envelope * (x0 * $eb4fc4a00fc6fb7d$var$cos(omega1 * t) + (beta * x0 + v0) / omega1 * $eb4fc4a00fc6fb7d$var$sin(omega1 * t));
            else if (beta == omega0) fraction = -x0 + envelope * (x0 + (beta * x0 + v0) * t);
            else fraction = -x0 + envelope * (x0 * $eb4fc4a00fc6fb7d$var$cosh(omega2 * t) + (beta * x0 + v0) / omega2 * $eb4fc4a00fc6fb7d$var$sinh(omega2 * t));
            return fraction;
        };
    }
    #initialVelocityForVelocityAxis(axis) {
        switch(axis){
            case $eb4fc4a00fc6fb7d$var$SpringTimingParameters.VelocityAxis.x:
                return this.initialVelocity.dx;
            case $eb4fc4a00fc6fb7d$var$SpringTimingParameters.VelocityAxis.y:
                return this.initialVelocity.dy;
            default:
                return 0;
        }
    }
    static get VelocityAxis() {
        return {
            x: 1,
            y: 2
        };
    }
}
var $eb4fc4a00fc6fb7d$export$2e2bcd8739ae039 = $eb4fc4a00fc6fb7d$var$SpringTimingParameters;


// 
// TimingCurve.js
// Cacao
// 
// Created on 5/8/23
// 
const $78e7515453ca2290$export$45db2fc2f15997e7 = (t)=>{
    return t;
};
const $78e7515453ca2290$export$2d59ca22077f6eab = (t)=>{
    return t * t;
};
const $78e7515453ca2290$export$be35423d31ba201e = (t)=>{
    return t * (2 - t);
};
const $78e7515453ca2290$export$42add3d9cb3645a2 = (t)=>{
    return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
const $78e7515453ca2290$export$5da70c9577229d30 = (t)=>{
    return t * t * t;
};
const $78e7515453ca2290$export$1157fb72e7fbceb5 = (t)=>{
    return --t * t * t + 1;
};
const $78e7515453ca2290$export$24656b269d8df7d6 = (t)=>{
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
const $78e7515453ca2290$export$c3d8280971f5e7ab = (t)=>{
    return t * t * t * t;
};
const $78e7515453ca2290$export$fb9e4320a4025f10 = (t)=>{
    return 1 - --t * t * t * t;
};
const $78e7515453ca2290$export$bd93209e120f4915 = (t)=>{
    return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
const $78e7515453ca2290$export$d5a2637b851d40fa = (t)=>{
    return t * t * t * t * t;
};
const $78e7515453ca2290$export$54ef52175ef1a966 = (t)=>{
    return 1 + --t * t * t * t * t;
};
const $78e7515453ca2290$export$40df750f1044ce5e = (t)=>{
    return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};


class $1c98d5f0dd1e30db$var$PropertyAnimator {
    constructor(options = {}){
        const { autoreverses: autoreverses = true, repeatCount: repeatCount = 0, interruptAnimationEvents: interruptAnimationEvents = [] } = options;
        if (options.timingParameters) this.timing = options.timingParameters.copy();
        else if (options.timingCurve) this.timing = {
            copyTimingFunction: ()=>options.timingCurve
        };
        else this.timing = {
            copyTimingFunction: ()=>$78e7515453ca2290$export$24656b269d8df7d6
        };
        this.autoreverses = autoreverses;
        this.repeatCount = repeatCount;
        this.interruptAnimationEvents = [
            "mousewheel",
            "touchstart"
        ] + interruptAnimationEvents;
    }
    animate(target, to, duration, completion) {
        if (!target) throw "PropertyAnimator: Cannot instantiate an animator without a target.";
        if (this.animating) this.stopAnimation();
        let properties1;
        const createAnimationForKey = (key, flags)=>{
            const fromValue = target[key], toValue = to[key];
            if (fromValue != toValue) {
                const timing = this.timing.copyTimingFunction(flags);
                return new (0, $ff409bc474e7092d$export$2e2bcd8739ae039)(key, fromValue, toValue, timing);
            }
            return undefined;
        };
        const { x: x, y: y } = (0, $eb4fc4a00fc6fb7d$export$2e2bcd8739ae039).VelocityAxis;
        if (to instanceof (0, $cba996667aa58736$export$baf26146a414f24a)) properties1 = [
            createAnimationForKey("x", {
                velocityAxis: x
            }),
            createAnimationForKey("y", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else if (to instanceof (0, $cba996667aa58736$export$cb6da89c6af1a8ec)) properties1 = [
            createAnimationForKey("width", {
                velocityAxis: x
            }),
            createAnimationForKey("height", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else if (to instanceof (0, $cba996667aa58736$export$c79fc6492f3af13d)) properties1 = [
            createAnimationForKey("origin.x", {
                velocityAxis: x
            }),
            createAnimationForKey("origin.y", {
                velocityAxis: y
            }),
            createAnimationForKey("size.width", {
                velocityAxis: x
            }),
            createAnimationForKey("size.height", {
                velocityAxis: y
            })
        ].filter(Boolean);
        else {
            properties1 = [];
            for(const key in to){
                const property = createAnimationForKey(key);
                if (property) properties1.push(property);
            }
        }
        this.target = target;
        this.duration = Math.max(duration, 0.1);
        this.beginTime = 0.0;
        this.properties = properties1;
        this.completion = completion;
        this.completed = false;
        this.startAnimation();
    }
    update() {
        if (this.beginTime == 0.0) this.beginTime = new Date().getTime();
        else {
            let deltaTime = new Date().getTime() - this.beginTime;
            let progress = deltaTime / this.duration;
            let target = this.target;
            this.updateTarget(progress);
        }
    }
    updateTarget(progress) {
        const target = this.target;
        function out(value, unit) {
            if (unit) value = String(value) + unit;
            return value;
        }
        function set(object, keyPath, value) {
            let components = keyPath.split("."), componentsCount = components.length;
            if (componentsCount > 1) {
                let count = componentsCount - 1;
                for(let idx = 0; idx < count; idx += 1)object = object[components[idx]];
            }
            let lastPathComponent = componentsCount > 0 ? components[componentsCount - 1] : keyPath;
            object[lastPathComponent] = value;
            return object;
        }
        if (progress < 1.0) {
            if (1 - progress < 0.001) {
                for (const property of this.properties)set(target, property.key, out(property.toValue, property.unit));
                this.complete();
            } else for (const property of this.properties){
                const percent = property.timing(progress);
                const value = property.fromValue + (property.toValue - property.fromValue) * percent;
                set(target, property.key, out(value, property.unit));
            }
        } else {
            for (const property of this.properties)set(target, property.key, out(property.toValue, property.unit));
            this.complete();
        }
    }
    complete() {
        let iteration = this.iterationCount + 1;
        let completed = iteration > this.repeatCount;
        if (!completed) {
            this.beginTime = 0.0;
            if (this.autoreverses) {
                const reversed = [];
                for (const property of properties)reversed.push(property.reversed);
                this.properties = reversed;
            } else this.updateTarget(0.0) // Manually update target to initial value.
            ;
        }
        this.iterationCount = iteration;
        if (completed) {
            this.completed = true;
            this.stopAnimation();
        }
    }
    stopAnimation() {
        if (!this.animating) return;
        this.animating = false;
        let targetScrollEventHandler = this.targetScrollEventHandler;
        if (targetScrollEventHandler) this.target.removeEventListener(targetScrollEventHandler);
        let request = this.frameRequest;
        if (request) cancelAnimationFrame(request);
        let completion = this.completion;
        if (completion) completion(this.completed);
        this.completion = undefined;
    }
    startAnimation() {
        if (this.animating) return;
        this.animating = true;
        this.iterationCount = 0;
        const targetScrollEventHandler = this.stopAnimation.bind(this);
        // if (this.target.addEventListener) {
        //   for (const name of this.interruptAnimationEvents) {
        //     this.target.addEventListener(name, targetScrollEventHandler)
        //   }
        // }
        const update = this.update.bind(this);
        const animate = ()=>{
            update();
            schedule();
            if (this.animating) {
                const { didAnimate: didAnimate } = this;
                if (didAnimate) didAnimate();
            }
        };
        const schedule = ()=>{
            if (this.animating) this.frameRequest = requestAnimationFrame(animate, this);
        };
        schedule();
    }
}
var $1c98d5f0dd1e30db$export$2e2bcd8739ae039 = $1c98d5f0dd1e30db$var$PropertyAnimator;










class $14d50b1536b6b818$var$RootHeaderView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    makeNode(document) {
        return document.createElement("header");
    }
    constructor(){
        super();
        this.node.innerHTML = `
      <figure class="mark"></figure>
      
      <nav>
        <a href="https://matias.me/" target="_blank">Website</a>
      </nav>
    `;
    }
}
var $14d50b1536b6b818$export$2e2bcd8739ae039 = $14d50b1536b6b818$var$RootHeaderView;



class $ace68b3a13623495$var$SpringboardLayout {
    static layout({ itemCount: itemCount, containerNode: containerNode } = options) {
        const itemSize = {
            width: 108,
            height: 142
        };
        const gap = 32;
        const padding = {
            top: 32,
            left: 32,
            right: 32,
            bottom: 72
        };
        const containerNodeSize = containerNode.getBoundingClientRect();
        const containerSize = {
            width: containerNodeSize.width - padding.left - padding.right,
            height: containerNodeSize.height - padding.top - padding.bottom
        };
        const minimumLines = 1, minimumItemsPerLine = 1;
        const totalItemWidth = itemSize.width + gap;
        const totalItemHeight = itemSize.height + gap;
        const itemsPerLine = Math.max(Math.floor((containerSize.width + gap) / totalItemWidth), minimumItemsPerLine);
        const lines = Math.max(Math.floor((containerSize.height + gap) / totalItemHeight), minimumLines);
        const maximumItemsPerLine = 5;
        const constrainedItemsPerLine = Math.min(itemsPerLine, maximumItemsPerLine);
        const maximumLines = Math.ceil(itemCount / constrainedItemsPerLine);
        const contrainedItemSize = {
            width: (containerSize.width - (constrainedItemsPerLine - 1) * gap) / constrainedItemsPerLine
        };
        const constrainedLines = Math.min(lines, maximumLines);
        return new $ace68b3a13623495$var$SpringboardLayout(constrainedLines, constrainedItemsPerLine);
    }
    constructor(rows, columns){
        this.rows = rows;
        this.columns = columns;
    }
    isEquivalent(otherLayout) {
        if (this == otherLayout) return true;
        if (this.rows == otherLayout.rows && this.columns == otherLayout.columns) return true;
        return false;
    }
}
var $ace68b3a13623495$export$2e2bcd8739ae039 = $ace68b3a13623495$var$SpringboardLayout;



var $3c24900110178db7$exports = {};
var $73070b84089da74c$exports = {};
$73070b84089da74c$exports = new URL("books.95459a42.png", import.meta.url).toString();


var $672513e24636bdb9$exports = {};
$672513e24636bdb9$exports = new URL("dribbble.d2d23e80.png", import.meta.url).toString();


var $94583c0225ccc12c$exports = {};
$94583c0225ccc12c$exports = new URL("games.3d92c2c3.png", import.meta.url).toString();


var $f069d0ea11c077e6$exports = {};
$f069d0ea11c077e6$exports = new URL("github.30ecc23c.png", import.meta.url).toString();


var $74fb768b16ed1578$exports = {};
$74fb768b16ed1578$exports = new URL("instagram.fd36ef2c.png", import.meta.url).toString();


var $66ca5e57cd00939e$exports = {};
$66ca5e57cd00939e$exports = new URL("last.fm.f914f671.png", import.meta.url).toString();


var $992d4ef8a258a769$exports = {};
$992d4ef8a258a769$exports = new URL("mail.683966a2.png", import.meta.url).toString();


var $87f1c9a0c37a552b$exports = {};
$87f1c9a0c37a552b$exports = new URL("mastodon.712941ad.png", import.meta.url).toString();


var $df33c0356946746d$exports = {};
$df33c0356946746d$exports = new URL("movies.8d8423e6.png", import.meta.url).toString();


var $e71363a280fe9e47$exports = {};
$e71363a280fe9e47$exports = new URL("music.baea1521.png", import.meta.url).toString();


var $8e123fdfc077296c$exports = {};
$8e123fdfc077296c$exports = new URL("threads.ca5154e1.png", import.meta.url).toString();


var $7372914614b93c9e$exports = {};
$7372914614b93c9e$exports = new URL("tiktok.6e60b867.png", import.meta.url).toString();


var $995b60fa048335aa$exports = {};
$995b60fa048335aa$exports = new URL("twitter.ecaf83d0.png", import.meta.url).toString();


var $ae4cb0613cdc0b10$exports = {};
$ae4cb0613cdc0b10$exports = new URL("youtube.51c2a9ac.png", import.meta.url).toString();


$3c24900110178db7$exports = {
    "books.png": $73070b84089da74c$exports,
    "dribbble.png": $672513e24636bdb9$exports,
    "games.png": $94583c0225ccc12c$exports,
    "github.png": $f069d0ea11c077e6$exports,
    "instagram.png": $74fb768b16ed1578$exports,
    "last.fm.png": $66ca5e57cd00939e$exports,
    "mail.png": $992d4ef8a258a769$exports,
    "mastodon.png": $87f1c9a0c37a552b$exports,
    "movies.png": $df33c0356946746d$exports,
    "music.png": $e71363a280fe9e47$exports,
    "threads.png": $8e123fdfc077296c$exports,
    "tiktok.png": $7372914614b93c9e$exports,
    "twitter.png": $995b60fa048335aa$exports,
    "youtube.png": $ae4cb0613cdc0b10$exports
};


var $82ef22afcd893f8d$exports = {};
var $88ba475b2fc275d3$exports = {};
$88ba475b2fc275d3$exports = new URL("book.8e19e8c6.png", import.meta.url).toString();


var $4ecacc35cbfeb654$exports = {};
$4ecacc35cbfeb654$exports = new URL("close-button-dark.d0fa1169.png", import.meta.url).toString();


var $0fdb55bb56591c8c$exports = {};
$0fdb55bb56591c8c$exports = new URL("close-button.0c1916bf.png", import.meta.url).toString();


var $2767c0bfda2f2b09$exports = {};
$2767c0bfda2f2b09$exports = new URL("logo.bdb3b38f.png", import.meta.url).toString();


var $af4943e228e04a1d$exports = {};
$af4943e228e04a1d$exports = new URL("movie-case.43301a8e.png", import.meta.url).toString();


var $aa10d1a71aafb01e$exports = {};
$aa10d1a71aafb01e$exports = new URL("open-external.c4f71fa9.svg", import.meta.url).toString();


var $0cda6460c18b8f0e$exports = {};
$0cda6460c18b8f0e$exports = new URL("shelf-background.0e6f710f.png", import.meta.url).toString();


var $f98b706e66679152$exports = {};
$f98b706e66679152$exports = new URL("shelf-foreground.38006fce.png", import.meta.url).toString();


$82ef22afcd893f8d$exports = {
    "book.png": $88ba475b2fc275d3$exports,
    "close-button-dark.png": $4ecacc35cbfeb654$exports,
    "close-button.png": $0fdb55bb56591c8c$exports,
    "logo.png": $2767c0bfda2f2b09$exports,
    "movie-case.png": $af4943e228e04a1d$exports,
    "open-external.svg": $aa10d1a71aafb01e$exports,
    "shelf-background.png": $0cda6460c18b8f0e$exports,
    "shelf-foreground.png": $f98b706e66679152$exports
};


var $22bfca6e648b3dd6$exports = {};
var $3189dc9ea1bda912$exports = {};
$3189dc9ea1bda912$exports = new URL("ask-iwata.964d26a0.jpg", import.meta.url).toString();


var $53abcf99093ce935$exports = {};
$53abcf99093ce935$exports = new URL("brief-answers-to-the-big-questions.04a4cf8a.jpg", import.meta.url).toString();


var $eb9512d210393a19$exports = {};
$eb9512d210393a19$exports = new URL("game-engine-black-book-doom.ab3da887.jpg", import.meta.url).toString();


var $cfc8d18588af149a$exports = {};
$cfc8d18588af149a$exports = new URL("how-to.8bee216e.jpg", import.meta.url).toString();


var $4c104b0eb0984b1b$exports = {};
$4c104b0eb0984b1b$exports = new URL("inside-out-a-personal-history-of-pink-floyd.dfdd26c5.jpg", import.meta.url).toString();


var $816b068bd91579ad$exports = {};
$816b068bd91579ad$exports = new URL("jacked-the-outlaw-story-of-grand-theft-auto.c7c3a455.jpg", import.meta.url).toString();


var $0469b6cf927eb5f1$exports = {};
$0469b6cf927eb5f1$exports = new URL("macintosh-human-interface-guidelines.67bb3c69.jpg", import.meta.url).toString();


var $bafc9b09a47b6bdd$exports = {};
$bafc9b09a47b6bdd$exports = new URL("make-something-wonderful.59144c13.jpg", import.meta.url).toString();


var $fec94f6830a2b3ba$exports = {};
$fec94f6830a2b3ba$exports = new URL("masters-of-doom.fc534c2f.jpg", import.meta.url).toString();


var $9a26a70f3b798ef0$exports = {};
$9a26a70f3b798ef0$exports = new URL("nasa-graphics-standards-manual.130d17ac.jpg", import.meta.url).toString();


var $92353b63bff1a388$exports = {};
$92353b63bff1a388$exports = new URL("saucerful-of-secrets-the-pink-floyd-odyssey.fa731654.jpg", import.meta.url).toString();


var $6edf5954f2a969d6$exports = {};
$6edf5954f2a969d6$exports = new URL("steve-jobs.d2d147fb.jpg", import.meta.url).toString();


var $8a0431eee741a383$exports = {};
$8a0431eee741a383$exports = new URL("the-apple-ii-age.3967eaa8.jpg", import.meta.url).toString();


var $1008031a1ef6b129$exports = {};
$1008031a1ef6b129$exports = new URL("the-design-of-everyday-things.60a4bcc9.jpg", import.meta.url).toString();


var $8f74355a77219449$exports = {};
$8f74355a77219449$exports = new URL("what-if.e2b9918f.jpg", import.meta.url).toString();


var $ea3216416c21ab22$exports = {};
$ea3216416c21ab22$exports = new URL("amnesia-the-dark-descent.158ecd04.jpg", import.meta.url).toString();


var $034ad9cc216af999$exports = {};
$034ad9cc216af999$exports = new URL("animal-crossing-new-horizons.3636af97.jpg", import.meta.url).toString();


var $5512eae2e7d6993b$exports = {};
$5512eae2e7d6993b$exports = new URL("bugs-bunny-lost-in-time.ac1ce06e.jpg", import.meta.url).toString();


var $6d48e8b703eee28b$exports = {};
$6d48e8b703eee28b$exports = new URL("captain-toad-treasure-tracker.4ee46b85.jpg", import.meta.url).toString();


var $e82e9624b3ab51a8$exports = {};
$e82e9624b3ab51a8$exports = new URL("conkers-pocket-tales.6ab35446.jpg", import.meta.url).toString();


var $9203e7e532bae01f$exports = {};
$9203e7e532bae01f$exports = new URL("crash-bandicoot-warped.d3b5b930.jpg", import.meta.url).toString();


var $522c8fe25f67ae5c$exports = {};
$522c8fe25f67ae5c$exports = new URL("crash-bandicoot.5c4ed6c1.jpg", import.meta.url).toString();


var $babf5f44cab6d4e0$exports = {};
$babf5f44cab6d4e0$exports = new URL("crash-team-racing.0076f535.jpg", import.meta.url).toString();


var $909eef835cd5d716$exports = {};
$909eef835cd5d716$exports = new URL("donkey-kong-country-tropical-freeze.ef16120a.jpg", import.meta.url).toString();


var $de2f48c2bb879744$exports = {};
$de2f48c2bb879744$exports = new URL("donkey-kong-country.0242c9f5.jpg", import.meta.url).toString();


var $ead92f5db69ca5c3$exports = {};
$ead92f5db69ca5c3$exports = new URL("doom-2016.d579ad93.jpg", import.meta.url).toString();


var $71b0fc2df5bac409$exports = {};
$71b0fc2df5bac409$exports = new URL("doom-3.d9f27418.jpg", import.meta.url).toString();


var $ac5d2478a64aaada$exports = {};
$ac5d2478a64aaada$exports = new URL("doom.221ebb02.jpg", import.meta.url).toString();


var $52240bd842324c60$exports = {};
$52240bd842324c60$exports = new URL("duck-hunt.c4203f51.jpg", import.meta.url).toString();


var $9838f67e6aa5f576$exports = {};
$9838f67e6aa5f576$exports = new URL("firewatch.6aa0c214.jpg", import.meta.url).toString();


var $04b417e3b791aeb9$exports = {};
$04b417e3b791aeb9$exports = new URL("galaga.926721b8.jpg", import.meta.url).toString();


var $017eda6d78a2a3c4$exports = {};
$017eda6d78a2a3c4$exports = new URL("game-watch-gallery-2.c0a8badf.jpg", import.meta.url).toString();


var $9ec040aa06a66a93$exports = {};
$9ec040aa06a66a93$exports = new URL("glider.19e4343a.jpg", import.meta.url).toString();


var $00d3b5fd42b654ff$exports = {};
$00d3b5fd42b654ff$exports = new URL("gran-turismo.6f22df6e.jpg", import.meta.url).toString();


var $439fce4480e56d90$exports = {};
$439fce4480e56d90$exports = new URL("grand-theft-auto-iii.4014f79e.jpg", import.meta.url).toString();


var $a14b222c9f13a6bb$exports = {};
$a14b222c9f13a6bb$exports = new URL("grand-theft-auto-iv.90c33c3d.jpg", import.meta.url).toString();


var $95c8f879f51ea0a4$exports = {};
$95c8f879f51ea0a4$exports = new URL("grand-theft-auto-san-andreas.f5f0e8d2.jpg", import.meta.url).toString();


var $b6cd9ac0294a07af$exports = {};
$b6cd9ac0294a07af$exports = new URL("grand-theft-auto-v.c878c95c.jpg", import.meta.url).toString();


var $5a4d6fff4ff49a4a$exports = {};
$5a4d6fff4ff49a4a$exports = new URL("grand-theft-auto-vice-city-stories.8b3ac3b7.jpg", import.meta.url).toString();


var $bf354a21d5d9d750$exports = {};
$bf354a21d5d9d750$exports = new URL("grand-theft-auto-vice-city.457d62a4.jpg", import.meta.url).toString();


var $f9f2b03f61419ed8$exports = {};
$f9f2b03f61419ed8$exports = new URL("half-life.88409114.jpg", import.meta.url).toString();


var $c6736b7ce456209e$exports = {};
$c6736b7ce456209e$exports = new URL("halo-combat-evolved.e4ad87c1.jpg", import.meta.url).toString();


var $32393daee8f2142e$exports = {};
$32393daee8f2142e$exports = new URL("halo-reach.6b8226a5.jpg", import.meta.url).toString();


var $3d0571f5c1bb4abd$exports = {};
$3d0571f5c1bb4abd$exports = new URL("jackie-chan-stuntmaster.f837a5ea.jpg", import.meta.url).toString();


var $ad3081b44c603a91$exports = {};
$ad3081b44c603a91$exports = new URL("legacy-of-kain-soul-reaver.afcab6c1.jpg", import.meta.url).toString();


var $353e03e1102d80b1$exports = {};
$353e03e1102d80b1$exports = new URL("luigis-mansion-3.1f6949d8.jpg", import.meta.url).toString();


var $30f41700fa363352$exports = {};
$30f41700fa363352$exports = new URL("luigis-mansion-dark-moon.b8ded8b0.jpg", import.meta.url).toString();


var $41b1c13255588cfb$exports = {};
$41b1c13255588cfb$exports = new URL("luigis-mansion.446ffadb.jpg", import.meta.url).toString();


var $5f1071d4480b7816$exports = {};
$5f1071d4480b7816$exports = new URL("machinarium.7969e817.jpg", import.meta.url).toString();


var $c73924e8e7d9e8a8$exports = {};
$c73924e8e7d9e8a8$exports = new URL("mario-kart-7.9c7fafd5.jpg", import.meta.url).toString();


var $8212dae226a849ca$exports = {};
$8212dae226a849ca$exports = new URL("mario-kart-8.e964caa0.jpg", import.meta.url).toString();


var $4483754184bae492$exports = {};
$4483754184bae492$exports = new URL("mario-kart-super-circuit.bf060a88.jpg", import.meta.url).toString();


var $574ff1960a7aca8b$exports = {};
$574ff1960a7aca8b$exports = new URL("metroid-dread.32b103fa.jpg", import.meta.url).toString();


var $daf56dd592ee8d9c$exports = {};
$daf56dd592ee8d9c$exports = new URL("minecraft.e1e2e134.jpg", import.meta.url).toString();


var $6f12807fd3230be4$exports = {};
$6f12807fd3230be4$exports = new URL("need-for-speed-high-stakes.36678b9e.jpg", import.meta.url).toString();


var $c127daf22fd47363$exports = {};
$c127daf22fd47363$exports = new URL("need-for-speed-porsche-unleashed.3b5e99f8.jpg", import.meta.url).toString();


var $2bb78a15b6404411$exports = {};
$2bb78a15b6404411$exports = new URL("nuts-and-milk.423d34b4.jpg", import.meta.url).toString();


var $f58e42a628b17456$exports = {};
$f58e42a628b17456$exports = new URL("pokmon-leafgreen.91184c5d.jpg", import.meta.url).toString();


var $40595236fd13aa92$exports = {};
$40595236fd13aa92$exports = new URL("portal-2.9ec1b515.jpg", import.meta.url).toString();


var $49fa3f590ab27a6c$exports = {};
$49fa3f590ab27a6c$exports = new URL("portal.8b5dbe9e.jpg", import.meta.url).toString();


var $24036f39b70284be$exports = {};
$24036f39b70284be$exports = new URL("quake-4.de0d9612.jpg", import.meta.url).toString();


var $3aebc52d5fd1fd62$exports = {};
$3aebc52d5fd1fd62$exports = new URL("quake-ii.c9fb184a.jpg", import.meta.url).toString();


var $d6936c2209566085$exports = {};
$d6936c2209566085$exports = new URL("quake-iii-arena.75fe5a8a.jpg", import.meta.url).toString();


var $39953bcdd40bb61b$exports = {};
$39953bcdd40bb61b$exports = new URL("rayman-2-the-great-escape.70ca5cd7.jpg", import.meta.url).toString();


var $938438c861d34f6e$exports = {};
$938438c861d34f6e$exports = new URL("rollercoaster-tycoon.4d35d60a.jpg", import.meta.url).toString();


var $0b304579de3cb917$exports = {};
$0b304579de3cb917$exports = new URL("roundabout.f8c29998.jpg", import.meta.url).toString();


var $e091bf2f9982f833$exports = {};
$e091bf2f9982f833$exports = new URL("soccer.5e1d6e95.jpg", import.meta.url).toString();


var $648afb57ed87de74$exports = {};
$648afb57ed87de74$exports = new URL("star-wars-episode-i-the-phantom-menace.08a3a2fb.jpg", import.meta.url).toString();


var $03db62768e82cd83$exports = {};
$03db62768e82cd83$exports = new URL("super-mario-bros.c95070a5.jpg", import.meta.url).toString();


var $c733d6ca13f5ea00$exports = {};
$c733d6ca13f5ea00$exports = new URL("super-mario-odyssey.27494f11.jpg", import.meta.url).toString();


var $d87db0631a4f2d20$exports = {};
$d87db0631a4f2d20$exports = new URL("tetris-dx.09b65387.jpg", import.meta.url).toString();


var $2d9d884024316d69$exports = {};
$2d9d884024316d69$exports = new URL("tetris.ab45301f.jpg", import.meta.url).toString();


var $386021e8e4157b2d$exports = {};
$386021e8e4157b2d$exports = new URL("the-binding-of-isaac-rebirth.abca5131.jpg", import.meta.url).toString();


var $f5340d1d86702c57$exports = {};
$f5340d1d86702c57$exports = new URL("the-legend-of-zelda-breath-of-the-wild.0f1758f7.jpg", import.meta.url).toString();


var $bd4e0ef8645abd7a$exports = {};
$bd4e0ef8645abd7a$exports = new URL("the-legend-of-zelda-links-awakening.5cffc249.jpg", import.meta.url).toString();


var $e218e8b858b394eb$exports = {};
$e218e8b858b394eb$exports = new URL("the-legend-of-zelda-the-minish-cap.2f8e1404.jpg", import.meta.url).toString();


var $d22e0717eb3f630d$exports = {};
$d22e0717eb3f630d$exports = new URL("the-simpsons-hit-run.522a125f.jpg", import.meta.url).toString();


var $d9b2639cf0ce981d$exports = {};
$d9b2639cf0ce981d$exports = new URL("the-sims.df7c2b39.jpg", import.meta.url).toString();


var $cae25cae5f909f0e$exports = {};
$cae25cae5f909f0e$exports = new URL("the-stanley-parable.650dafe6.jpg", import.meta.url).toString();


var $77fb6bc14d1f399a$exports = {};
$77fb6bc14d1f399a$exports = new URL("tony-hawks-pro-skater-2.8ed69573.jpg", import.meta.url).toString();


var $e7b991069c6cddec$exports = {};
$e7b991069c6cddec$exports = new URL("undertale.3881d813.jpg", import.meta.url).toString();


var $510e585d2613795c$exports = {};
$510e585d2613795c$exports = new URL("uninvited.e2d4feef.jpg", import.meta.url).toString();


var $150e6be5f3ce497c$exports = {};
$150e6be5f3ce497c$exports = new URL("untitled-goose-game.a75ff61d.jpg", import.meta.url).toString();


var $564ed11697d810a6$exports = {};
$564ed11697d810a6$exports = new URL("12-angry-men.b8cd9b8d.jpg", import.meta.url).toString();


var $b8c4e91849f669d4$exports = {};
$b8c4e91849f669d4$exports = new URL("a-bugss-life.3fbea974.jpg", import.meta.url).toString();


var $2e9659a2f1494c0f$exports = {};
$2e9659a2f1494c0f$exports = new URL("airplane.4c9ccc43.jpg", import.meta.url).toString();


var $e72a02b99419c088$exports = {};
$e72a02b99419c088$exports = new URL("alien.b06df88b.jpg", import.meta.url).toString();


var $146af708de5b916a$exports = {};
$146af708de5b916a$exports = new URL("back-to-the-future-part-ii.ddc3b1ae.jpg", import.meta.url).toString();


var $a1dd76c918f5425d$exports = {};
$a1dd76c918f5425d$exports = new URL("back-to-the-future.7e05c591.jpg", import.meta.url).toString();


var $2738ae87e7593dd9$exports = {};
$2738ae87e7593dd9$exports = new URL("blade-runner.35e26245.jpg", import.meta.url).toString();


var $3623cc0952db87f7$exports = {};
$3623cc0952db87f7$exports = new URL("coco.2fe5eef7.jpg", import.meta.url).toString();


var $4c143813a4fa907c$exports = {};
$4c143813a4fa907c$exports = new URL("creating-rem-lezar.ba8e502a.jpg", import.meta.url).toString();


var $3fdbb41ef9cdb551$exports = {};
$3fdbb41ef9cdb551$exports = new URL("el-agente-topo.597ce564.jpg", import.meta.url).toString();


var $566fb14a5fced372$exports = {};
$566fb14a5fced372$exports = new URL("frank.b8f2b6b4.jpg", import.meta.url).toString();


var $fa731d6f0660dbd9$exports = {};
$fa731d6f0660dbd9$exports = new URL("her.a136dc86.jpg", import.meta.url).toString();


var $b955cd3bbe33b005$exports = {};
$b955cd3bbe33b005$exports = new URL("inception.70314cc4.jpg", import.meta.url).toString();


var $f28d9f68309cf772$exports = {};
$f28d9f68309cf772$exports = new URL("indiana-jones-and-the-last-crusade.fca31af3.jpg", import.meta.url).toString();


var $b4df037a1620bc21$exports = {};
$b4df037a1620bc21$exports = new URL("inglourious-basterds.63d541ad.jpg", import.meta.url).toString();


var $0c168b4db392ab21$exports = {};
$0c168b4db392ab21$exports = new URL("iron-man.0573953a.jpg", import.meta.url).toString();


var $baf45b25053a2243$exports = {};
$baf45b25053a2243$exports = new URL("jaws.09a09e40.jpg", import.meta.url).toString();


var $c7102be4b2d2595e$exports = {};
$c7102be4b2d2595e$exports = new URL("jiro-dreams-of-sushi.6ed0b8cf.jpg", import.meta.url).toString();


var $720ddd6e8e4def1f$exports = {};
$720ddd6e8e4def1f$exports = new URL("john-wick-chapter-2.54eac932.jpg", import.meta.url).toString();


var $d4cf24d064edf72c$exports = {};
$d4cf24d064edf72c$exports = new URL("john-wick-chapter-3-parabellum.11352e41.jpg", import.meta.url).toString();


var $eb531fcc646e77a9$exports = {};
$eb531fcc646e77a9$exports = new URL("john-wick-chapter-4.b03a2d44.jpg", import.meta.url).toString();


var $070e63b53e59f019$exports = {};
$070e63b53e59f019$exports = new URL("john-wick.dd61aa3a.jpg", import.meta.url).toString();


var $2f4df4d95964e510$exports = {};
$2f4df4d95964e510$exports = new URL("jurassic-park.e566137e.jpg", import.meta.url).toString();


var $e6e322312c412c8c$exports = {};
$e6e322312c412c8c$exports = new URL("kill-bill-vol-1.262efe85.jpg", import.meta.url).toString();


var $72ce0769cbd78272$exports = {};
$72ce0769cbd78272$exports = new URL("kill-bill-vol-2.7d39c5ce.jpg", import.meta.url).toString();


var $d350b9fcc7b19557$exports = {};
$d350b9fcc7b19557$exports = new URL("look-whos-back.d88f353d.jpg", import.meta.url).toString();


var $497c473aba22bbbb$exports = {};
$497c473aba22bbbb$exports = new URL("lost-in-translation.8daaa1e9.jpg", import.meta.url).toString();


var $9d2d0a3d1f840662$exports = {};
$9d2d0a3d1f840662$exports = new URL("once-upon-a-time-in-hollywood.ffb524f5.jpg", import.meta.url).toString();


var $f44d964e53281e71$exports = {};
$f44d964e53281e71$exports = new URL("parasite.24e5d54d.jpg", import.meta.url).toString();


var $e022fa57c6197f93$exports = {};
$e022fa57c6197f93$exports = new URL("pink-floyd-the-wall.badbc790.jpg", import.meta.url).toString();


var $cbb6397bfdbbadaa$exports = {};
$cbb6397bfdbbadaa$exports = new URL("pirates-of-silicon-valley.b5b25eb3.jpg", import.meta.url).toString();


var $c8d16215fd903c4d$exports = {};
$c8d16215fd903c4d$exports = new URL("pulp-fiction.63e5e1a8.jpg", import.meta.url).toString();


var $f0762e1da8a146ca$exports = {};
$f0762e1da8a146ca$exports = new URL("raiders-of-the-lost-ark.9e445228.jpg", import.meta.url).toString();


var $b6c85df9a9886cae$exports = {};
$b6c85df9a9886cae$exports = new URL("reservoir-dogs.354c797a.jpg", import.meta.url).toString();


var $d743fed18061c158$exports = {};
$d743fed18061c158$exports = new URL("star-wars.344e4ba8.jpg", import.meta.url).toString();


var $dfe35d9c22918130$exports = {};
$dfe35d9c22918130$exports = new URL("terminator-2-judgment-day.6ff6a76c.jpg", import.meta.url).toString();


var $2cefad2c4eaa909f$exports = {};
$2cefad2c4eaa909f$exports = new URL("the-empire-strikes-back.6a8e54c0.jpg", import.meta.url).toString();


var $9386ca82a24736b3$exports = {};
$9386ca82a24736b3$exports = new URL("the-good-the-bad-and-the-ugly.0eb28486.jpg", import.meta.url).toString();


var $cd8cf9691ea6aa90$exports = {};
$cd8cf9691ea6aa90$exports = new URL("the-incredibles.53bf004a.jpg", import.meta.url).toString();


var $dae38dd9e6d97e7e$exports = {};
$dae38dd9e6d97e7e$exports = new URL("the-matrix-reloaded.bac473a9.jpg", import.meta.url).toString();


var $67705e5173bc418a$exports = {};
$67705e5173bc418a$exports = new URL("the-matrix.44ffb4da.jpg", import.meta.url).toString();


var $a116cff0808f982b$exports = {};
$a116cff0808f982b$exports = new URL("the-parent-trap.de7c7942.jpg", import.meta.url).toString();


var $c4faff0234669420$exports = {};
$c4faff0234669420$exports = new URL("the-room.dfdb699b.jpg", import.meta.url).toString();


var $ce32c0f02225af6c$exports = {};
$ce32c0f02225af6c$exports = new URL("the-sixth-sense.b1863ca8.jpg", import.meta.url).toString();


var $04e1991ae82d656a$exports = {};
$04e1991ae82d656a$exports = new URL("the-terminator.c42d5991.jpg", import.meta.url).toString();


var $2861b7b280673758$exports = {};
$2861b7b280673758$exports = new URL("toy-story.7d4d421e.jpg", import.meta.url).toString();


var $59ab31c838ac1e15$exports = {};
$59ab31c838ac1e15$exports = new URL("up.a89c722f.jpg", import.meta.url).toString();


var $1c4c0535f729f6f9$exports = {};
$1c4c0535f729f6f9$exports = new URL("waynes-world.8ad8d9bb.jpg", import.meta.url).toString();


var $115ff77bf6ef9d54$exports = {};
$115ff77bf6ef9d54$exports = new URL("whiplash.056f4428.jpg", import.meta.url).toString();


var $197906c1652bec67$exports = {};
$197906c1652bec67$exports = new URL("yellow-submarine.14b1dbe7.jpg", import.meta.url).toString();


var $d7f7c2ebd77f9927$exports = {};
$d7f7c2ebd77f9927$exports = new URL("31-minutos.8a14f7e3.jpg", import.meta.url).toString();


var $916599e31dce6550$exports = {};
$916599e31dce6550$exports = new URL("a-kind-of-magic.66f7ec29.jpg", import.meta.url).toString();


var $9ee16373c4b3bb9d$exports = {};
$9ee16373c4b3bb9d$exports = new URL("a-saucerful-of-secrets.6685f1af.jpg", import.meta.url).toString();


var $66dad6c88c9d48d6$exports = {};
$66dad6c88c9d48d6$exports = new URL("abbey-road.8fe8147a.jpg", import.meta.url).toString();


var $3a9b8796a050bdba$exports = {};
$3a9b8796a050bdba$exports = new URL("all-things-must-pass.92c1ec9a.jpg", import.meta.url).toString();


var $dae5cff7e4c4c8cb$exports = {};
$dae5cff7e4c4c8cb$exports = new URL("alturas-de-macchu-picchu.811e5b1b.jpg", import.meta.url).toString();


var $6c91f42c2808bdbf$exports = {};
$6c91f42c2808bdbf$exports = new URL("amnesiac.8d5e8e9e.jpg", import.meta.url).toString();


var $75e5d35a9e7b3ae2$exports = {};
$75e5d35a9e7b3ae2$exports = new URL("animals.d957d910.jpg", import.meta.url).toString();


var $9f4759528e392cbc$exports = {};
$9f4759528e392cbc$exports = new URL("artaud.1a019dea.jpg", import.meta.url).toString();


var $f3488f9550347e3b$exports = {};
$f3488f9550347e3b$exports = new URL("atom-heart-mother.7e2bf9fe.jpg", import.meta.url).toString();


var $2cc25388f31c089d$exports = {};
$2cc25388f31c089d$exports = new URL("autobahn.f10725be.jpg", import.meta.url).toString();


var $8b25e59255f16d65$exports = {};
$8b25e59255f16d65$exports = new URL("autobanh.f10725be.jpg", import.meta.url).toString();


var $1de17130d5056572$exports = {};
$1de17130d5056572$exports = new URL("barrett.3973ff2f.jpg", import.meta.url).toString();


var $55b98b92b8fa01eb$exports = {};
$55b98b92b8fa01eb$exports = new URL("blackstar.af67465d.jpg", import.meta.url).toString();


var $542795743e843267$exports = {};
$542795743e843267$exports = new URL("broken-china.1ecae915.jpg", import.meta.url).toString();


var $1ad319e59a50fb6a$exports = {};
$1ad319e59a50fb6a$exports = new URL("canto-por-travesura.75fc5bef.jpg", import.meta.url).toString();


var $2cad620ad4b2735b$exports = {};
$2cad620ad4b2735b$exports = new URL("dark-side-of-the-moon.b1205143.jpg", import.meta.url).toString();


var $b03d182e1e9ab029$exports = {};
$b03d182e1e9ab029$exports = new URL("demon-days.910965f1.jpg", import.meta.url).toString();


var $ebc3c40c30711cd1$exports = {};
$ebc3c40c30711cd1$exports = new URL("die-mensch-maschine.3733a4aa.jpg", import.meta.url).toString();


var $c0c1187bee97f6a2$exports = {};
$c0c1187bee97f6a2$exports = new URL("discovery.031e5fb7.jpg", import.meta.url).toString();


var $7c54a2eba7abd2df$exports = {};
$7c54a2eba7abd2df$exports = new URL("endless-summer-vacation.eb111709.jpg", import.meta.url).toString();


var $861c1a439fca4b27$exports = {};
$861c1a439fca4b27$exports = new URL("eye-in-the-sky.b804cb5d.jpg", import.meta.url).toString();


var $b353a6186f059748$exports = {};
$b353a6186f059748$exports = new URL("fuerza-natural.5dc4cef9.jpg", import.meta.url).toString();


var $bfd5f342be572ea5$exports = {};
$bfd5f342be572ea5$exports = new URL("future-nostalgia.e13c167e.jpg", import.meta.url).toString();


var $cae4ce182d74fff0$exports = {};
$cae4ce182d74fff0$exports = new URL("george-harrison.ca124720.jpg", import.meta.url).toString();


var $b7de533a445e93c3$exports = {};
$b7de533a445e93c3$exports = new URL("gorillaz.8f0b864a.jpg", import.meta.url).toString();


var $d0f8e3268155ba83$exports = {};
$d0f8e3268155ba83$exports = new URL("hounds-of-love.1fb3b811.jpg", import.meta.url).toString();


var $53146fbbcd7c65b9$exports = {};
$53146fbbcd7c65b9$exports = new URL("i-robot.9f758afc.jpg", import.meta.url).toString();


var $daed19b24e1cceb4$exports = {};
$daed19b24e1cceb4$exports = new URL("in-rainbows.edcee051.jpg", import.meta.url).toString();


var $e785b8da2446d0c1$exports = {};
$e785b8da2446d0c1$exports = new URL("is-this-the-life-we-really-want.30f36fe5.jpg", import.meta.url).toString();


var $43ea1be535aefc2b$exports = {};
$43ea1be535aefc2b$exports = new URL("les-concerts-en-chine.814d0e5f.jpg", import.meta.url).toString();


var $dfc84631b2d57d45$exports = {};
$dfc84631b2d57d45$exports = new URL("let-it-be.2948ae19.jpg", import.meta.url).toString();


var $9afbdbc57bedefa5$exports = {};
$9afbdbc57bedefa5$exports = new URL("lets-dance.1f8444b3.jpg", import.meta.url).toString();


var $5c61306208a63897$exports = {};
$5c61306208a63897$exports = new URL("living-in-the-material-world.cdc72979.jpg", import.meta.url).toString();


var $00774dfb959d9929$exports = {};
$00774dfb959d9929$exports = new URL("magical-mystery-tour.b3fa66f3.jpg", import.meta.url).toString();


var $39b3e0336dc0fa54$exports = {};
$39b3e0336dc0fa54$exports = new URL("meddle.af40fbcb.jpg", import.meta.url).toString();


var $565c2841de2aaf59$exports = {};
$565c2841de2aaf59$exports = new URL("metropolis-pt-2-scenes-from-a-memory.89c39a8e.jpg", import.meta.url).toString();


var $d6fd38004580ea1e$exports = {};
$d6fd38004580ea1e$exports = new URL("mind-games.c1edc79c.jpg", import.meta.url).toString();


var $74a5ff734bc66bff$exports = {};
$74a5ff734bc66bff$exports = new URL("moon-safari.34421d9f.jpg", import.meta.url).toString();


var $1c17957625fcf955$exports = {};
$1c17957625fcf955$exports = new URL("morning-phase.06187377.jpg", import.meta.url).toString();


var $abb6bb8e85efb02c$exports = {};
$abb6bb8e85efb02c$exports = new URL("motomami.f4c4f716.jpg", import.meta.url).toString();


var $d0b1b756732df51f$exports = {};
$d0b1b756732df51f$exports = new URL("mutter.e2d733cf.jpg", import.meta.url).toString();


var $bfd49b206f7a0c60$exports = {};
$bfd49b206f7a0c60$exports = new URL("nevermind.6c3fa173.jpg", import.meta.url).toString();


var $11227a8e386a380c$exports = {};
$11227a8e386a380c$exports = new URL("obscured-by-clouds.071ffa91.jpg", import.meta.url).toString();


var $0e1a511ac747949e$exports = {};
$0e1a511ac747949e$exports = new URL("ok-computer.fbc6cabc.jpg", import.meta.url).toString();


var $1b24758e7332cadb$exports = {};
$1b24758e7332cadb$exports = new URL("plastic-beach.5e3cd5bb.jpg", import.meta.url).toString();


var $fb305b6f24a0038d$exports = {};
$fb305b6f24a0038d$exports = new URL("plastic-ono-band.0e3f0451.jpg", import.meta.url).toString();


var $001def5060ba180f$exports = {};
$001def5060ba180f$exports = new URL("pulse.a0fbf5f2.jpg", import.meta.url).toString();


var $f26e77678292a45e$exports = {};
$f26e77678292a45e$exports = new URL("ray-charles.fc0f0936.jpg", import.meta.url).toString();


var $90754a378c964942$exports = {};
$90754a378c964942$exports = new URL("reise-reise.25dd0066.jpg", import.meta.url).toString();


var $d1e096accdfa4fd8$exports = {};
$d1e096accdfa4fd8$exports = new URL("revolver.9b863470.jpg", import.meta.url).toString();


var $f136e8ae692233b2$exports = {};
$f136e8ae692233b2$exports = new URL("roy-pablo.c7be3222.jpg", import.meta.url).toString();


var $eeed452d19b7094d$exports = {};
$eeed452d19b7094d$exports = new URL("sehnsucht.6fe7b764.jpg", import.meta.url).toString();


var $642824c4e411197f$exports = {};
$642824c4e411197f$exports = new URL("sgt-peppers-lonely-hearts-club-band.57eedfd6.jpg", import.meta.url).toString();


var $0f88d78e8eabea27$exports = {};
$0f88d78e8eabea27$exports = new URL("signos.cc2fa5a6.jpg", import.meta.url).toString();


var $99e561139b1a7e57$exports = {};
$99e561139b1a7e57$exports = new URL("solar-power.b54c23ac.jpg", import.meta.url).toString();


var $2a84fd89dc289de5$exports = {};
$2a84fd89dc289de5$exports = new URL("techno-pop.bdacc2a6.jpg", import.meta.url).toString();


var $a70ac88ba8fa1560$exports = {};
$a70ac88ba8fa1560$exports = new URL("the-beatles-1962-1966.572ddb19.jpg", import.meta.url).toString();


var $79677628d2f8153b$exports = {};
$79677628d2f8153b$exports = new URL("the-beatles-the-white-album.4b1047d1.jpg", import.meta.url).toString();


var $9ba856de8a2baaec$exports = {};
$9ba856de8a2baaec$exports = new URL("the-division-bell.560a294a.jpg", import.meta.url).toString();


var $60d275bbc76df058$exports = {};
$60d275bbc76df058$exports = new URL("the-piper-at-the-gates-of-dawn.40117553.jpg", import.meta.url).toString();


var $23d8dbae130afe2d$exports = {};
$23d8dbae130afe2d$exports = new URL("the-rutles.2c6dc1ce.jpg", import.meta.url).toString();


var $8890773b5fbcfe69$exports = {};
$8890773b5fbcfe69$exports = new URL("the-wall.75590785.jpg", import.meta.url).toString();


var $93c261a360f57aff$exports = {};
$93c261a360f57aff$exports = new URL("thriller.1ae5dafc.jpg", import.meta.url).toString();


var $eec729cbd31a4d23$exports = {};
$eec729cbd31a4d23$exports = new URL("toto.13114708.jpg", import.meta.url).toString();


var $2489ad4f0915487a$exports = {};
$2489ad4f0915487a$exports = new URL("tour-de-france.78a7ce69.jpg", import.meta.url).toString();


var $00b40f49a8835592$exports = {};
$00b40f49a8835592$exports = new URL("toxicity.30a59ce5.jpg", import.meta.url).toString();


var $7f091e00ac88626a$exports = {};
$7f091e00ac88626a$exports = new URL("trans-europa-express.b991e0ef.jpg", import.meta.url).toString();


var $7b4771bdde9b5841$exports = {};
$7b4771bdde9b5841$exports = new URL("tubular-bells.2c3595bd.jpg", import.meta.url).toString();


var $b14527526925f152$exports = {};
$b14527526925f152$exports = new URL("ummagumma.d915e91a.jpg", import.meta.url).toString();


var $fe7d2a616413d9a4$exports = {};
$fe7d2a616413d9a4$exports = new URL("viva-chile.f591260a.jpg", import.meta.url).toString();


var $aaed2192f08b13d1$exports = {};
$aaed2192f08b13d1$exports = new URL("wet-dream.83df5046.jpg", import.meta.url).toString();


var $27352da2b10f6b4a$exports = {};
$27352da2b10f6b4a$exports = new URL("wish-you-were-here.15efede5.jpg", import.meta.url).toString();


var $2f43a157a1719541$exports = {};
$2f43a157a1719541$exports = new URL("yellow-submarine.12d44e45.jpg", import.meta.url).toString();


$22bfca6e648b3dd6$exports = {
    "books": {
        "ask-iwata.jpg": $3189dc9ea1bda912$exports,
        "brief-answers-to-the-big-questions.jpg": $53abcf99093ce935$exports,
        "game-engine-black-book-doom.jpg": $eb9512d210393a19$exports,
        "how-to.jpg": $cfc8d18588af149a$exports,
        "inside-out-a-personal-history-of-pink-floyd.jpg": $4c104b0eb0984b1b$exports,
        "jacked-the-outlaw-story-of-grand-theft-auto.jpg": $816b068bd91579ad$exports,
        "macintosh-human-interface-guidelines.jpg": $0469b6cf927eb5f1$exports,
        "make-something-wonderful.jpg": $bafc9b09a47b6bdd$exports,
        "masters-of-doom.jpg": $fec94f6830a2b3ba$exports,
        "nasa-graphics-standards-manual.jpg": $9a26a70f3b798ef0$exports,
        "saucerful-of-secrets-the-pink-floyd-odyssey.jpg": $92353b63bff1a388$exports,
        "steve-jobs.jpg": $6edf5954f2a969d6$exports,
        "the-apple-ii-age.jpg": $8a0431eee741a383$exports,
        "the-design-of-everyday-things.jpg": $1008031a1ef6b129$exports,
        "what-if.jpg": $8f74355a77219449$exports
    },
    "games": {
        "amnesia-the-dark-descent.jpg": $ea3216416c21ab22$exports,
        "animal-crossing-new-horizons.jpg": $034ad9cc216af999$exports,
        "bugs-bunny-lost-in-time.jpg": $5512eae2e7d6993b$exports,
        "captain-toad-treasure-tracker.jpg": $6d48e8b703eee28b$exports,
        "conkers-pocket-tales.jpg": $e82e9624b3ab51a8$exports,
        "crash-bandicoot-warped.jpg": $9203e7e532bae01f$exports,
        "crash-bandicoot.jpg": $522c8fe25f67ae5c$exports,
        "crash-team-racing.jpg": $babf5f44cab6d4e0$exports,
        "donkey-kong-country-tropical-freeze.jpg": $909eef835cd5d716$exports,
        "donkey-kong-country.jpg": $de2f48c2bb879744$exports,
        "doom-2016.jpg": $ead92f5db69ca5c3$exports,
        "doom-3.jpg": $71b0fc2df5bac409$exports,
        "doom.jpg": $ac5d2478a64aaada$exports,
        "duck-hunt.jpg": $52240bd842324c60$exports,
        "firewatch.jpg": $9838f67e6aa5f576$exports,
        "galaga.jpg": $04b417e3b791aeb9$exports,
        "game-watch-gallery-2.jpg": $017eda6d78a2a3c4$exports,
        "glider.jpg": $9ec040aa06a66a93$exports,
        "gran-turismo.jpg": $00d3b5fd42b654ff$exports,
        "grand-theft-auto-iii.jpg": $439fce4480e56d90$exports,
        "grand-theft-auto-iv.jpg": $a14b222c9f13a6bb$exports,
        "grand-theft-auto-san-andreas.jpg": $95c8f879f51ea0a4$exports,
        "grand-theft-auto-v.jpg": $b6cd9ac0294a07af$exports,
        "grand-theft-auto-vice-city-stories.jpg": $5a4d6fff4ff49a4a$exports,
        "grand-theft-auto-vice-city.jpg": $bf354a21d5d9d750$exports,
        "half-life.jpg": $f9f2b03f61419ed8$exports,
        "halo-combat-evolved.jpg": $c6736b7ce456209e$exports,
        "halo-reach.jpg": $32393daee8f2142e$exports,
        "jackie-chan-stuntmaster.jpg": $3d0571f5c1bb4abd$exports,
        "legacy-of-kain-soul-reaver.jpg": $ad3081b44c603a91$exports,
        "luigis-mansion-3.jpg": $353e03e1102d80b1$exports,
        "luigis-mansion-dark-moon.jpg": $30f41700fa363352$exports,
        "luigis-mansion.jpg": $41b1c13255588cfb$exports,
        "machinarium.jpg": $5f1071d4480b7816$exports,
        "mario-kart-7.jpg": $c73924e8e7d9e8a8$exports,
        "mario-kart-8.jpg": $8212dae226a849ca$exports,
        "mario-kart-super-circuit.jpg": $4483754184bae492$exports,
        "metroid-dread.jpg": $574ff1960a7aca8b$exports,
        "minecraft.jpg": $daf56dd592ee8d9c$exports,
        "need-for-speed-high-stakes.jpg": $6f12807fd3230be4$exports,
        "need-for-speed-porsche-unleashed.jpg": $c127daf22fd47363$exports,
        "nuts-and-milk.jpg": $2bb78a15b6404411$exports,
        "pokmon-leafgreen.jpg": $f58e42a628b17456$exports,
        "portal-2.jpg": $40595236fd13aa92$exports,
        "portal.jpg": $49fa3f590ab27a6c$exports,
        "quake-4.jpg": $24036f39b70284be$exports,
        "quake-ii.jpg": $3aebc52d5fd1fd62$exports,
        "quake-iii-arena.jpg": $d6936c2209566085$exports,
        "rayman-2-the-great-escape.jpg": $39953bcdd40bb61b$exports,
        "rollercoaster-tycoon.jpg": $938438c861d34f6e$exports,
        "roundabout.jpg": $0b304579de3cb917$exports,
        "soccer.jpg": $e091bf2f9982f833$exports,
        "star-wars-episode-i-the-phantom-menace.jpg": $648afb57ed87de74$exports,
        "super-mario-bros.jpg": $03db62768e82cd83$exports,
        "super-mario-odyssey.jpg": $c733d6ca13f5ea00$exports,
        "tetris-dx.jpg": $d87db0631a4f2d20$exports,
        "tetris.jpg": $2d9d884024316d69$exports,
        "the-binding-of-isaac-rebirth.jpg": $386021e8e4157b2d$exports,
        "the-legend-of-zelda-breath-of-the-wild.jpg": $f5340d1d86702c57$exports,
        "the-legend-of-zelda-links-awakening.jpg": $bd4e0ef8645abd7a$exports,
        "the-legend-of-zelda-the-minish-cap.jpg": $e218e8b858b394eb$exports,
        "the-simpsons-hit-run.jpg": $d22e0717eb3f630d$exports,
        "the-sims.jpg": $d9b2639cf0ce981d$exports,
        "the-stanley-parable.jpg": $cae25cae5f909f0e$exports,
        "tony-hawks-pro-skater-2.jpg": $77fb6bc14d1f399a$exports,
        "undertale.jpg": $e7b991069c6cddec$exports,
        "uninvited.jpg": $510e585d2613795c$exports,
        "untitled-goose-game.jpg": $150e6be5f3ce497c$exports
    },
    "movies": {
        "12-angry-men.jpg": $564ed11697d810a6$exports,
        "a-bugss-life.jpg": $b8c4e91849f669d4$exports,
        "airplane.jpg": $2e9659a2f1494c0f$exports,
        "alien.jpg": $e72a02b99419c088$exports,
        "back-to-the-future-part-ii.jpg": $146af708de5b916a$exports,
        "back-to-the-future.jpg": $a1dd76c918f5425d$exports,
        "blade-runner.jpg": $2738ae87e7593dd9$exports,
        "coco.jpg": $3623cc0952db87f7$exports,
        "creating-rem-lezar.jpg": $4c143813a4fa907c$exports,
        "el-agente-topo.jpg": $3fdbb41ef9cdb551$exports,
        "frank.jpg": $566fb14a5fced372$exports,
        "her.jpg": $fa731d6f0660dbd9$exports,
        "inception.jpg": $b955cd3bbe33b005$exports,
        "indiana-jones-and-the-last-crusade.jpg": $f28d9f68309cf772$exports,
        "inglourious-basterds.jpg": $b4df037a1620bc21$exports,
        "iron-man.jpg": $0c168b4db392ab21$exports,
        "jaws.jpg": $baf45b25053a2243$exports,
        "jiro-dreams-of-sushi.jpg": $c7102be4b2d2595e$exports,
        "john-wick-chapter-2.jpg": $720ddd6e8e4def1f$exports,
        "john-wick-chapter-3-parabellum.jpg": $d4cf24d064edf72c$exports,
        "john-wick-chapter-4.jpg": $eb531fcc646e77a9$exports,
        "john-wick.jpg": $070e63b53e59f019$exports,
        "jurassic-park.jpg": $2f4df4d95964e510$exports,
        "kill-bill-vol-1.jpg": $e6e322312c412c8c$exports,
        "kill-bill-vol-2.jpg": $72ce0769cbd78272$exports,
        "look-whos-back.jpg": $d350b9fcc7b19557$exports,
        "lost-in-translation.jpg": $497c473aba22bbbb$exports,
        "once-upon-a-time-in-hollywood.jpg": $9d2d0a3d1f840662$exports,
        "parasite.jpg": $f44d964e53281e71$exports,
        "pink-floyd-the-wall.jpg": $e022fa57c6197f93$exports,
        "pirates-of-silicon-valley.jpg": $cbb6397bfdbbadaa$exports,
        "pulp-fiction.jpg": $c8d16215fd903c4d$exports,
        "raiders-of-the-lost-ark.jpg": $f0762e1da8a146ca$exports,
        "reservoir-dogs.jpg": $b6c85df9a9886cae$exports,
        "star-wars.jpg": $d743fed18061c158$exports,
        "terminator-2-judgment-day.jpg": $dfe35d9c22918130$exports,
        "the-empire-strikes-back.jpg": $2cefad2c4eaa909f$exports,
        "the-good-the-bad-and-the-ugly.jpg": $9386ca82a24736b3$exports,
        "the-incredibles.jpg": $cd8cf9691ea6aa90$exports,
        "the-matrix-reloaded.jpg": $dae38dd9e6d97e7e$exports,
        "the-matrix.jpg": $67705e5173bc418a$exports,
        "the-parent-trap.jpg": $a116cff0808f982b$exports,
        "the-room.jpg": $c4faff0234669420$exports,
        "the-sixth-sense.jpg": $ce32c0f02225af6c$exports,
        "the-terminator.jpg": $04e1991ae82d656a$exports,
        "toy-story.jpg": $2861b7b280673758$exports,
        "up.jpg": $59ab31c838ac1e15$exports,
        "waynes-world.jpg": $1c4c0535f729f6f9$exports,
        "whiplash.jpg": $115ff77bf6ef9d54$exports,
        "yellow-submarine.jpg": $197906c1652bec67$exports
    },
    "music": {
        "31-minutos.jpg": $d7f7c2ebd77f9927$exports,
        "a-kind-of-magic.jpg": $916599e31dce6550$exports,
        "a-saucerful-of-secrets.jpg": $9ee16373c4b3bb9d$exports,
        "abbey-road.jpg": $66dad6c88c9d48d6$exports,
        "all-things-must-pass.jpg": $3a9b8796a050bdba$exports,
        "alturas-de-macchu-picchu.jpg": $dae5cff7e4c4c8cb$exports,
        "amnesiac.jpg": $6c91f42c2808bdbf$exports,
        "animals.jpg": $75e5d35a9e7b3ae2$exports,
        "artaud.jpg": $9f4759528e392cbc$exports,
        "atom-heart-mother.jpg": $f3488f9550347e3b$exports,
        "autobahn.jpg": $2cc25388f31c089d$exports,
        "autobanh.jpg": $8b25e59255f16d65$exports,
        "barrett.jpg": $1de17130d5056572$exports,
        "blackstar.jpg": $55b98b92b8fa01eb$exports,
        "broken-china.jpg": $542795743e843267$exports,
        "canto-por-travesura.jpg": $1ad319e59a50fb6a$exports,
        "dark-side-of-the-moon.jpg": $2cad620ad4b2735b$exports,
        "demon-days.jpg": $b03d182e1e9ab029$exports,
        "die-mensch-maschine.jpg": $ebc3c40c30711cd1$exports,
        "discovery.jpg": $c0c1187bee97f6a2$exports,
        "endless-summer-vacation.jpg": $7c54a2eba7abd2df$exports,
        "eye-in-the-sky.jpg": $861c1a439fca4b27$exports,
        "fuerza-natural.jpg": $b353a6186f059748$exports,
        "future-nostalgia.jpg": $bfd5f342be572ea5$exports,
        "george-harrison.jpg": $cae4ce182d74fff0$exports,
        "gorillaz.jpg": $b7de533a445e93c3$exports,
        "hounds-of-love.jpg": $d0f8e3268155ba83$exports,
        "i-robot.jpg": $53146fbbcd7c65b9$exports,
        "in-rainbows.jpg": $daed19b24e1cceb4$exports,
        "is-this-the-life-we-really-want.jpg": $e785b8da2446d0c1$exports,
        "les-concerts-en-chine.jpg": $43ea1be535aefc2b$exports,
        "let-it-be.jpg": $dfc84631b2d57d45$exports,
        "lets-dance.jpg": $9afbdbc57bedefa5$exports,
        "living-in-the-material-world.jpg": $5c61306208a63897$exports,
        "magical-mystery-tour.jpg": $00774dfb959d9929$exports,
        "meddle.jpg": $39b3e0336dc0fa54$exports,
        "metropolis-pt-2-scenes-from-a-memory.jpg": $565c2841de2aaf59$exports,
        "mind-games.jpg": $d6fd38004580ea1e$exports,
        "moon-safari.jpg": $74a5ff734bc66bff$exports,
        "morning-phase.jpg": $1c17957625fcf955$exports,
        "motomami.jpg": $abb6bb8e85efb02c$exports,
        "mutter.jpg": $d0b1b756732df51f$exports,
        "nevermind.jpg": $bfd49b206f7a0c60$exports,
        "obscured-by-clouds.jpg": $11227a8e386a380c$exports,
        "ok-computer.jpg": $0e1a511ac747949e$exports,
        "plastic-beach.jpg": $1b24758e7332cadb$exports,
        "plastic-ono-band.jpg": $fb305b6f24a0038d$exports,
        "pulse.jpg": $001def5060ba180f$exports,
        "ray-charles.jpg": $f26e77678292a45e$exports,
        "reise-reise.jpg": $90754a378c964942$exports,
        "revolver.jpg": $d1e096accdfa4fd8$exports,
        "roy-pablo.jpg": $f136e8ae692233b2$exports,
        "sehnsucht.jpg": $eeed452d19b7094d$exports,
        "sgt-peppers-lonely-hearts-club-band.jpg": $642824c4e411197f$exports,
        "signos.jpg": $0f88d78e8eabea27$exports,
        "solar-power.jpg": $99e561139b1a7e57$exports,
        "techno-pop.jpg": $2a84fd89dc289de5$exports,
        "the-beatles-1962-1966.jpg": $a70ac88ba8fa1560$exports,
        "the-beatles-the-white-album.jpg": $79677628d2f8153b$exports,
        "the-division-bell.jpg": $9ba856de8a2baaec$exports,
        "the-piper-at-the-gates-of-dawn.jpg": $60d275bbc76df058$exports,
        "the-rutles.jpg": $23d8dbae130afe2d$exports,
        "the-wall.jpg": $8890773b5fbcfe69$exports,
        "thriller.jpg": $93c261a360f57aff$exports,
        "toto.jpg": $eec729cbd31a4d23$exports,
        "tour-de-france.jpg": $2489ad4f0915487a$exports,
        "toxicity.jpg": $00b40f49a8835592$exports,
        "trans-europa-express.jpg": $7f091e00ac88626a$exports,
        "tubular-bells.jpg": $7b4771bdde9b5841$exports,
        "ummagumma.jpg": $b14527526925f152$exports,
        "viva-chile.jpg": $fe7d2a616413d9a4$exports,
        "wet-dream.jpg": $aaed2192f08b13d1$exports,
        "wish-you-were-here.jpg": $27352da2b10f6b4a$exports,
        "yellow-submarine.jpg": $2f43a157a1719541$exports
    }
};


var $ac4e782dc62cac3b$exports = {};
$ac4e782dc62cac3b$exports = {
    "title": "Mat\xedas Mart\xednez's Directory",
    "description": "A directory of links and things.",
    "links": [
        {
            "Twitter": "https://twitter.com/martinez"
        },
        {
            "Mastodon": "https://mastodon.social/@martinez"
        },
        {
            "Instagram": "https://www.instagram.com/matmartinez"
        },
        {
            "Threads": "https://www.threads.net/@matmartinez"
        },
        {
            "YouTube": "https://www.youtube.com/c/Mat\xedasM"
        },
        {
            "Github": "https://github.com/matmartinez"
        },
        {
            "Last.fm": "https://www.last.fm/user/martinezmatias"
        },
        {
            "TikTok": "https://www.tiktok.com/@matias.meme"
        },
        {
            "Dribbble": "https://dribbble.com/matmartinez"
        },
        {
            "Mail": "mailto:hello@matias.me"
        }
    ],
    "collections": [
        {
            "name": "Music",
            "title": "Music I like",
            "id": "music",
            "prefers-light-theme": true,
            "collection": [
                {
                    "title": "Moon Safari",
                    "author": "Air",
                    "year": 1998,
                    "url": "https://music.apple.com/us/album/moon-safari/693063670"
                },
                {
                    "title": "Eye In The Sky",
                    "author": "The Alan Parsons Project",
                    "year": 1982,
                    "url": "https://music.apple.com/us/album/eye-in-the-sky/1205670750"
                },
                {
                    "title": "I Robot",
                    "author": "The Alan Parsons Project",
                    "year": 1977,
                    "url": "https://music.apple.com/us/album/i-robot/1240904821"
                },
                {
                    "title": "The Beatles / 1962-1966",
                    "author": "The Beatles",
                    "year": 1973,
                    "url": "https://music.apple.com/us/album/the-beatles-1962-1966-the-red-album/1441132965"
                },
                {
                    "title": "Magical Mystery Tour",
                    "author": "The Beatles",
                    "year": 1967,
                    "url": "https://music.apple.com/us/album/magical-mystery-tour/1441163490"
                },
                {
                    "title": "Yellow Submarine",
                    "author": "The Beatles",
                    "year": 1969,
                    "url": "https://music.apple.com/us/album/yellow-submarine/1441164525"
                },
                {
                    "title": "Revolver",
                    "author": "The Beatles",
                    "year": 1966,
                    "url": "https://music.apple.com/us/album/revolver/1441164670"
                },
                {
                    "title": "Sgt. Pepper's Lonely Hearts Club Band",
                    "author": "The Beatles",
                    "year": 1967,
                    "url": "https://music.apple.com/us/album/sgt-peppers-lonely-hearts-club-band-deluxe-edition/1440881011"
                },
                {
                    "title": "The Beatles (The White Album)",
                    "author": "The Beatles",
                    "year": 1968,
                    "url": "https://music.apple.com/us/album/sgt-peppers-lonely-hearts-club-band-deluxe-edition/1440881011"
                },
                {
                    "title": "Let It Be",
                    "author": "The Beatles",
                    "year": 1970,
                    "url": "https://music.apple.com/us/album/let-it-be/1441164495"
                },
                {
                    "title": "Abbey Road",
                    "author": "The Beatles",
                    "year": 1969,
                    "url": "https://music.apple.com/us/album/abbey-road-super-deluxe-edition-2019-remix-remaster/1474833332"
                },
                {
                    "title": "Mind Games",
                    "author": "John Lennon",
                    "year": 1973,
                    "url": "https://music.apple.com/us/album/mind-games/1440854146"
                },
                {
                    "title": "Morning Phase",
                    "author": "Beck",
                    "year": 2014,
                    "url": "https://music.apple.com/us/album/morning-phase/797897966"
                },
                {
                    "title": "Roy Pablo",
                    "author": "boy pablo",
                    "year": 2017,
                    "url": "https://music.apple.com/us/album/roy-pablo-ep/1234864053"
                },
                {
                    "title": "Discovery",
                    "author": "Daft Punk",
                    "year": 2001,
                    "url": "https://music.apple.com/us/album/discovery/697194953"
                },
                {
                    "title": "Let's Dance",
                    "author": "David Bowie",
                    "year": 1983,
                    "url": "https://music.apple.com/us/album/lets-dance-2018-remaster/1475002920"
                },
                {
                    "title": "Blackstar",
                    "author": "David Bowie",
                    "year": 2016,
                    "url": "https://music.apple.com/us/album/lets-dance-2018-remaster/1475002920"
                },
                {
                    "title": "Metropolis, Pt. 2: Scenes from a Memory",
                    "author": "Dream Theater",
                    "year": 1999,
                    "url": "https://music.apple.com/us/album/lets-dance-2018-remaster/1475002920"
                },
                {
                    "title": "Future Nostalgia",
                    "author": "Dua Lipa",
                    "year": 2020,
                    "url": "https://music.apple.com/us/album/future-nostalgia/1538003494"
                },
                {
                    "title": "\xa1Viva Chile!",
                    "author": "Electrodom\xe9sticos",
                    "year": 1986,
                    "url": "https://music.apple.com/us/album/viva-chile/1483607881"
                },
                {
                    "title": "All Things Must Pass",
                    "author": "George Harrison",
                    "year": 1970,
                    "url": "https://music.apple.com/us/album/all-things-must-pass-50th-anniversary-super-deluxe/1666771841"
                },
                {
                    "title": "Living in the Material World",
                    "author": "George Harrison",
                    "year": 1973,
                    "url": "https://music.apple.com/us/album/living-in-the-material-world/1666653516"
                },
                {
                    "title": "George Harrison",
                    "author": "George Harrison",
                    "year": 1979,
                    "url": "https://music.apple.com/us/album/george-harrison/1666655988"
                },
                {
                    "title": "Gorillaz",
                    "author": "Gorillaz",
                    "year": 2001,
                    "url": "https://music.apple.com/us/album/gorillaz/850576570"
                },
                {
                    "title": "Demon Days",
                    "author": "Gorillaz",
                    "year": 2005,
                    "url": "https://music.apple.com/us/album/demon-days/850571319"
                },
                {
                    "title": "Plastic Beach",
                    "author": "Gorillaz",
                    "year": 2010,
                    "url": "https://music.apple.com/us/album/plastic-beach-deluxe-version/859841880"
                },
                {
                    "title": "Fuerza Natural",
                    "author": "Gustavo Cerati",
                    "year": 2009,
                    "url": "https://music.apple.com/us/album/fuerza-natural/1358493163"
                },
                {
                    "title": "Les concerts en Chine",
                    "author": "Jean-Michel Jarre",
                    "year": 1982,
                    "url": "https://music.apple.com/us/album/les-concerts-en-chine-1981/1719813501"
                },
                {
                    "title": "Hounds of Love",
                    "author": "Kate Bush",
                    "year": 1985,
                    "url": "https://music.apple.com/us/album/hounds-of-love-2018-remaster/1675560565"
                },
                {
                    "title": "Autobahn",
                    "author": "Kraftwerk",
                    "year": 1974,
                    "url": "https://music.apple.com/us/album/autobahn-remastered/726154713"
                },
                {
                    "title": "Trans-Europa Express",
                    "author": "Kraftwerk",
                    "year": 1977,
                    "url": "https://music.apple.com/us/album/trans-europe-express-2009-remaster/726144557"
                },
                {
                    "title": "Die Mensch-Maschine",
                    "author": "Kraftwerk",
                    "year": 1978,
                    "url": "https://music.apple.com/us/album/the-man-machine-remastered/726157248"
                },
                {
                    "title": "Techno Pop",
                    "author": "Kraftwerk",
                    "year": 1986,
                    "url": "https://music.apple.com/us/album/the-man-machine-remastered/726157248"
                },
                {
                    "title": "Tour de France",
                    "author": "Kraftwerk",
                    "year": 2003,
                    "url": "https://music.apple.com/us/album/tour-de-france-remastered/726341054"
                },
                {
                    "title": "Solar Power",
                    "author": "Lorde",
                    "year": 2021,
                    "url": "https://music.apple.com/us/album/solar-power/1572940891"
                },
                {
                    "title": "Alturas de Macchu Picchu",
                    "author": "Los Jaivas",
                    "year": 1981,
                    "url": "https://music.apple.com/us/album/alturas-de-macchu-picchu/1607400773"
                },
                {
                    "title": "Thriller",
                    "author": "Michael Jackson",
                    "year": 1982,
                    "url": "https://music.apple.com/us/album/thriller/269572838"
                },
                {
                    "title": "Tubular Bells",
                    "author": "Mike Oldfield",
                    "year": 1973,
                    "url": "https://music.apple.com/us/album/tubular-bells/994663630"
                },
                {
                    "title": "Endless Summer Vacation",
                    "author": "Miley Cyrus",
                    "year": 2023,
                    "url": "https://music.apple.com/us/album/tubular-bells/994663630"
                },
                {
                    "title": "Nevermind",
                    "author": "Nirvana",
                    "year": 1991,
                    "url": "https://music.apple.com/us/album/endless-summer-vacation/1702906527"
                },
                {
                    "title": "Artaud",
                    "author": "Pescado Rabioso",
                    "year": 1973,
                    "url": "https://music.apple.com/us/album/artaud/321645242"
                },
                {
                    "title": "The Piper at the Gates of Dawn",
                    "author": "Pink Floyd",
                    "year": 1967,
                    "url": "https://music.apple.com/us/album/the-piper-at-the-gates-of-dawn/1065975041"
                },
                {
                    "title": "A Saucerful of Secrets",
                    "author": "Pink Floyd",
                    "year": 1968,
                    "url": "https://music.apple.com/us/album/a-saucerful-of-secrets/1065974579"
                },
                {
                    "title": "Ummagumma",
                    "author": "Pink Floyd",
                    "year": 1969,
                    "url": "https://music.apple.com/us/album/ummagumma/1065978159"
                },
                {
                    "title": "Atom Heart Mother",
                    "author": "Pink Floyd",
                    "year": 1970,
                    "url": "https://music.apple.com/us/album/atom-heart-mother/1065975345"
                },
                {
                    "title": "Meddle",
                    "author": "Pink Floyd",
                    "year": 1971,
                    "url": "https://music.apple.com/us/album/meddle-2016-remaster/1065973614"
                },
                {
                    "title": "Obscured by Clouds",
                    "author": "Pink Floyd",
                    "year": 1972,
                    "url": "https://music.apple.com/us/album/obscured-by-clouds/1065975350"
                },
                {
                    "title": "Dark Side of the Moon",
                    "author": "Pink Floyd",
                    "year": 1973,
                    "url": "https://music.apple.com/us/album/obscured-by-clouds/1065975350"
                },
                {
                    "title": "Wish You Were Here",
                    "author": "Pink Floyd",
                    "year": 1975,
                    "url": "https://music.apple.com/us/album/wish-you-were-here/1065973975"
                },
                {
                    "title": "Animals",
                    "author": "Pink Floyd",
                    "year": 1977,
                    "url": "https://music.apple.com/us/album/animals/1065974284"
                },
                {
                    "title": "Wet Dream",
                    "author": "Richard Wright",
                    "year": 1978,
                    "url": "https://music.apple.com/us/album/wet-dream-2023-remix/1693925254"
                },
                {
                    "title": "The Wall",
                    "author": "Pink Floyd",
                    "year": 1979,
                    "url": "https://music.apple.com/us/album/wet-dream-2023-remix/1693925254"
                },
                {
                    "title": "The Division Bell",
                    "author": "Pink Floyd",
                    "year": 1994,
                    "url": "https://music.apple.com/us/album/wet-dream-2023-remix/1693925254"
                },
                {
                    "title": "Pulse",
                    "author": "Pink Floyd",
                    "year": 1995,
                    "url": "https://music.apple.com/us/album/wet-dream-2023-remix/1693925254"
                },
                {
                    "title": "Broken China",
                    "author": "Richard Wright",
                    "year": 1996,
                    "url": "https://en.wikipedia.org/wiki/Broken_China"
                },
                {
                    "title": "A Kind of Magic",
                    "author": "Queen",
                    "year": 1986,
                    "url": "https://music.apple.com/us/album/a-kind-of-magic/1440783166"
                },
                {
                    "title": "Amnesiac",
                    "author": "Radiohead",
                    "year": 2001,
                    "url": "https://music.apple.com/us/album/amnesiac/1097864180"
                },
                {
                    "title": "In Rainbows",
                    "author": "Radiohead",
                    "year": 2007,
                    "url": "https://music.apple.com/us/album/in-rainbows/1109714933"
                },
                {
                    "title": "OK Computer",
                    "author": "Radiohead",
                    "year": 1997,
                    "url": "https://music.apple.com/us/album/ok-computer/1097861387"
                },
                {
                    "title": "Sehnsucht",
                    "author": "Rammstein",
                    "year": 1997,
                    "url": "https://music.apple.com/us/album/sehnsucht/1390562159"
                },
                {
                    "title": "Mutter",
                    "author": "Rammstein",
                    "year": 2001,
                    "url": "https://music.apple.com/us/album/mutter/1440770702"
                },
                {
                    "title": "Reise, Reise",
                    "author": "Rammstein",
                    "year": 2004,
                    "url": "https://music.apple.com/us/album/reise-reise/1440734479"
                },
                {
                    "title": "Ray Charles",
                    "author": "Ray Charles",
                    "year": 1957,
                    "url": "https://music.apple.com/us/album/ray-charles/46592114"
                },
                {
                    "title": "Is This the Life We Really Want?",
                    "author": "Roger Waters",
                    "year": 2017,
                    "url": "https://music.apple.com/us/album/is-this-the-life-we-really-want/1227077689"
                },
                {
                    "title": "MOTOMAMI",
                    "author": "ROSAL\xcdA",
                    "year": 2022,
                    "url": "https://music.apple.com/us/album/motomami/1607918350"
                },
                {
                    "title": "The Rutles",
                    "author": "The Rutles",
                    "year": 1978,
                    "url": "https://music.apple.com/us/album/the-rutles/335832270"
                },
                {
                    "title": "Signos",
                    "author": "Soda Stereo",
                    "year": 1986,
                    "url": "https://music.apple.com/us/album/signos/321882453"
                },
                {
                    "title": "Barrett",
                    "author": "Syd Barrett",
                    "year": 1970,
                    "url": "https://music.apple.com/us/album/barrett/1111645897"
                },
                {
                    "title": "Toxicity",
                    "author": "System Of A Down",
                    "year": 2001,
                    "url": "https://music.apple.com/us/album/toxicity/273714443"
                },
                {
                    "title": "Toto",
                    "author": "Toto",
                    "year": 1978,
                    "url": "https://music.apple.com/us/album/toto/198226130"
                },
                {
                    "title": "Canto por Travesura",
                    "author": "Victor Jara",
                    "year": 1973,
                    "url": "https://music.apple.com/us/album/canto-por-travesura/1446799751"
                },
                {
                    "title": "Plastic Ono Band",
                    "author": "Yoko Ono",
                    "year": 1970,
                    "url": "https://music.apple.com/us/album/yoko-ono-plastic-ono-band-deluxe-edition/1149642244"
                },
                {
                    "title": "31 Minutos",
                    "author": "31 Minutos",
                    "year": 2003,
                    "url": "https://music.apple.com/us/album/31-minutos/1687546227"
                }
            ]
        },
        {
            "name": "Movies",
            "title": "Movies I like",
            "id": "movies",
            "collection": [
                {
                    "title": "The Matrix",
                    "author": "Lana & Lilly Wachowski",
                    "year": 1999,
                    "url": "https://www.imdb.com/title/tt0133093/"
                },
                {
                    "title": "The Matrix Reloaded",
                    "author": "Lana & Lilly Wachowski",
                    "year": 2003,
                    "url": "https://www.imdb.com/title/tt0234215/"
                },
                {
                    "title": "Frank",
                    "author": "Lenny Abrahamson",
                    "year": 2014,
                    "url": "https://www.imdb.com/title/tt1605717/"
                },
                {
                    "title": "Yellow Submarine",
                    "author": "George Dunning",
                    "year": 1968,
                    "url": "https://www.imdb.com/title/tt0063823/"
                },
                {
                    "title": "Indiana Jones and the Last Crusade",
                    "author": "Steven Spielberg",
                    "year": 1988,
                    "url": "https://www.imdb.com/title/tt0097576"
                },
                {
                    "title": "Raiders of the Lost Ark",
                    "author": "Steven Spielberg",
                    "year": 1981,
                    "url": "https://www.imdb.com/title/tt0082971/"
                },
                {
                    "title": "Jaws",
                    "author": "Steven Spielberg",
                    "year": 1975,
                    "url": "https://www.imdb.com/title/tt0073195/"
                },
                {
                    "title": "Jurassic Park",
                    "author": "Steven Spielberg",
                    "year": 1993,
                    "url": "https://www.imdb.com/title/tt0107290/"
                },
                {
                    "title": "Back to the Future",
                    "author": "Robert Zemeckis",
                    "year": 1985,
                    "url": "https://www.imdb.com/title/tt0060196/"
                },
                {
                    "title": "Back to the Future Part II",
                    "author": "Robert Zemeckis",
                    "year": 1989,
                    "url": "https://www.imdb.com/title/tt0096874/"
                },
                {
                    "title": "Jiro Dreams of Sushi",
                    "author": "David Gelb",
                    "year": 2011,
                    "url": "https://www.imdb.com/title/tt0060196/"
                },
                {
                    "title": "Whiplash",
                    "author": "Damien Chazelle",
                    "year": 2014,
                    "url": "https://www.imdb.com/title/tt2582802/"
                },
                {
                    "title": "The Sixth Sense",
                    "author": "M. Night Shyamalan",
                    "year": 1999,
                    "url": "https://www.imdb.com/title/tt2582802/"
                },
                {
                    "title": "Reservoir Dogs",
                    "author": "Quentin Tarantino",
                    "year": 1992,
                    "url": "https://www.imdb.com/title/tt0105236/"
                },
                {
                    "title": "Pulp Fiction",
                    "author": "Quentin Tarantino",
                    "year": 1994,
                    "url": "https://www.imdb.com/title/tt0110912/"
                },
                {
                    "title": "Kill Bill: Vol. 1",
                    "author": "Quentin Tarantino",
                    "year": 2003,
                    "url": "https://www.imdb.com/title/tt0266697/"
                },
                {
                    "title": "Kill Bill: Vol. 2",
                    "author": "Quentin Tarantino",
                    "year": 2004,
                    "url": "https://www.imdb.com/title/tt0378194/"
                },
                {
                    "title": "Inglourious Basterds",
                    "author": "Quentin Tarantino",
                    "year": 2009,
                    "url": "https://www.imdb.com/title/tt0361748/"
                },
                {
                    "title": "Once Upon a Time in Hollywood",
                    "author": "Quentin Tarantino",
                    "year": 2019,
                    "url": "https://www.imdb.com/title/tt7131622/"
                },
                {
                    "title": "John Wick",
                    "author": "Chad Stahelski",
                    "year": 2014,
                    "url": "https://www.imdb.com/title/tt2911666/"
                },
                {
                    "title": "John Wick: Chapter 2",
                    "author": "Chad Stahelski",
                    "year": 2017,
                    "url": "https://www.imdb.com/title/tt4425200/"
                },
                {
                    "title": "John Wick: Chapter 3 - Parabellum",
                    "author": "Chad Stahelski",
                    "year": 2019,
                    "url": "https://www.imdb.com/title/tt6146586/"
                },
                {
                    "title": "John Wick: Chapter 4",
                    "author": "Chad Stahelski",
                    "year": 2023,
                    "url": "https://www.imdb.com/title/tt10366206/"
                },
                {
                    "title": "Look Who's Back",
                    "author": "David Wnendt",
                    "year": 2015,
                    "url": "https://www.imdb.com/title/tt4176826/"
                },
                {
                    "title": "Lost in Translation",
                    "author": "Sofia Coppola",
                    "year": 2003,
                    "url": "https://www.imdb.com/title/tt0335266/"
                },
                {
                    "title": "Her",
                    "author": "Spike Jonze",
                    "year": 2013,
                    "url": "https://www.imdb.com/title/tt1798709/"
                },
                {
                    "title": "Parasite",
                    "author": "Bong Joon-ho",
                    "year": 2019,
                    "url": "https://www.imdb.com/title/tt6751668/"
                },
                {
                    "title": "The Parent Trap",
                    "author": "Nancy Meyers",
                    "year": 1998,
                    "url": "https://www.imdb.com/title/tt0120783/"
                },
                {
                    "title": "Pink Floyd: The Wall",
                    "author": "Alan Parker",
                    "year": 1982,
                    "url": "https://www.imdb.com/title/tt0084503/"
                },
                {
                    "title": "Pirates of Silicon Valley",
                    "author": "Martyn Burke",
                    "year": 1999,
                    "url": "https://www.imdb.com/title/tt0168122/"
                },
                {
                    "title": "Iron Man",
                    "author": "Jon Favreau",
                    "year": 2008,
                    "url": "https://www.imdb.com/title/tt0371746/"
                },
                {
                    "title": "The Room",
                    "author": "Tommy Wiseau",
                    "year": 2003,
                    "url": "https://www.imdb.com/title/tt0368226/"
                },
                {
                    "title": "Creating Rem Lezar",
                    "author": "Scott Zakarin",
                    "year": 1989,
                    "url": "https://www.imdb.com/title/tt0369348/"
                },
                {
                    "title": "Star Wars",
                    "author": "George Lucas",
                    "year": 1977,
                    "url": "https://www.imdb.com/title/tt0076759/"
                },
                {
                    "title": "The Empire Strikes Back",
                    "author": "Irvin Kershner",
                    "year": 1980,
                    "url": "https://www.imdb.com/title/tt0080684/"
                },
                {
                    "title": "The Terminator",
                    "author": "James Cameron",
                    "year": 1984,
                    "url": "https://www.imdb.com/title/tt0088247/"
                },
                {
                    "title": "Terminator 2: Judgment Day",
                    "author": "James Cameron",
                    "year": 1991,
                    "url": "https://www.imdb.com/title/tt0103064/"
                },
                {
                    "title": "Wayne's World",
                    "author": "Penelope Spheeris",
                    "year": 1992,
                    "url": "https://www.imdb.com/title/tt0105793/"
                },
                {
                    "title": "12 Angry Men",
                    "author": "Sidney Lumet",
                    "year": 1957,
                    "url": "https://www.imdb.com/title/tt0050083/"
                },
                {
                    "title": "Airplane!",
                    "author": "Jim Abrahams",
                    "year": 1980,
                    "url": "https://www.imdb.com/title/tt0080339/"
                },
                {
                    "title": "Toy Story",
                    "author": "John Lasseter",
                    "year": 1995,
                    "url": "https://www.imdb.com/title/tt0080339/"
                },
                {
                    "title": "A Bugs's Life",
                    "author": "John Lasseter",
                    "year": 1998,
                    "url": "https://www.imdb.com/title/tt0120623/"
                },
                {
                    "title": "The Incredibles",
                    "author": "Brad Bird",
                    "year": 2004,
                    "url": "https://www.imdb.com/title/tt0317705/"
                },
                {
                    "title": "Up",
                    "author": "Pete Docter",
                    "year": 2009,
                    "url": "https://www.imdb.com/title/tt1049413/"
                },
                {
                    "title": "Coco",
                    "author": "Lee Unkrich",
                    "year": 2017,
                    "url": "https://www.imdb.com/title/tt2380307/"
                },
                {
                    "title": "Inception",
                    "author": "Christopher Nolan",
                    "year": 2010,
                    "url": "https://www.imdb.com/title/tt1375666/"
                },
                {
                    "title": "Alien",
                    "author": "Ridley Scott",
                    "year": 1979,
                    "url": "https://www.imdb.com/title/tt0078748/"
                },
                {
                    "title": "Blade Runner",
                    "author": "Ridley Scott",
                    "year": 1982,
                    "url": "https://www.imdb.com/title/tt0083658/"
                },
                {
                    "title": "El agente topo",
                    "author": "Maite Alberdi",
                    "year": 2020,
                    "url": "https://www.imdb.com/title/tt0083658/"
                },
                {
                    "title": "The Good, the Bad and the Ugly",
                    "author": "Sergio Leone",
                    "year": 1966,
                    "url": "https://www.imdb.com/title/tt0060196/"
                }
            ]
        },
        {
            "name": "Books",
            "title": "Books I love",
            "id": "books",
            "collection": [
                {
                    "title": "The Apple II Age",
                    "author": "Laine Nooney",
                    "year": 2023,
                    "url": "https://www.amazon.com/Apple-II-Age-Computer-Personal/dp/0226816524"
                },
                {
                    "title": "Make Something Wonderful",
                    "author": "Steve Jobs Archive",
                    "year": 2023,
                    "url": "https://stevejobsarchive.com/book"
                },
                {
                    "title": "What If?",
                    "author": "Randall Munroe",
                    "year": 2014,
                    "url": "https://en.wikipedia.org/wiki/What_If%3F_(book)",
                    "size": [
                        214,
                        300
                    ]
                },
                {
                    "title": "Ask Iwata",
                    "author": "Satoru Iwata",
                    "year": 2021,
                    "url": "https://www.amazon.com/Ask-Iwata-Wisdom-Nintendos-Legendary/dp/197472154X"
                },
                {
                    "title": "Jacked: The Outlaw Story of Grand Theft Auto",
                    "author": "David Kushner",
                    "year": 2012,
                    "url": "https://en.wikipedia.org/wiki/Jacked%3A_The_Outlaw_Story_of_Grand_Theft_Auto"
                },
                {
                    "title": "How To",
                    "author": "Randall Munroe",
                    "year": 2019,
                    "url": "https://en.wikipedia.org/wiki/How_To_(book)",
                    "size": [
                        234,
                        300
                    ]
                },
                {
                    "title": "The Design of Everyday Things",
                    "author": "Donald Norman",
                    "year": 1988,
                    "url": "https://en.wikipedia.org/wiki/The_Design_of_Everyday_Things"
                },
                {
                    "title": "Masters of Doom",
                    "author": "David Kushner",
                    "year": 2003,
                    "url": "https://en.wikipedia.org/wiki/Masters_of_Doom",
                    "size": [
                        195,
                        300
                    ]
                },
                {
                    "title": "Inside Out: A Personal History of Pink Floyd",
                    "author": "Nick Mason",
                    "year": 2004,
                    "url": "https://en.wikipedia.org/wiki/Inside_Out%3A_A_Personal_History_of_Pink_Floyd"
                },
                {
                    "title": "Brief Answers to the Big Questions",
                    "author": "Stephen Hawking",
                    "year": 2018,
                    "url": "https://en.wikipedia.org/wiki/Brief_Answers_to_the_Big_Questions"
                },
                {
                    "title": "NASA Graphics Standards Manual",
                    "author": "NASA",
                    "year": 1976,
                    "url": "https://www.nasa.gov/image-article/nasa-graphics-standards-manual/"
                },
                {
                    "title": "Steve Jobs",
                    "author": "Walter Isaacson",
                    "year": 2011,
                    "url": "https://en.wikipedia.org/wiki/Steve_Jobs_(book)"
                },
                {
                    "title": "Game Engine Black Book: DOOM",
                    "author": "Fabien Sanglard",
                    "year": 2018,
                    "url": "https://fabiensanglard.net/gebbdoom/",
                    "size": [
                        242,
                        300
                    ]
                },
                {
                    "title": "Saucerful of Secrets: The Pink Floyd Odyssey",
                    "author": "Nicholas Schaffner",
                    "year": 1991,
                    "url": "https://www.amazon.com/Saucerful-Secrets-Pink-Floyd-Odyssey/dp/0385306849",
                    "size": [
                        197,
                        300
                    ]
                },
                {
                    "title": "Macintosh Human Interface Guidelines",
                    "author": "Apple",
                    "year": 1993,
                    "url": "https://www.amazon.com/Saucerful-Secrets-Pink-Floyd-Odyssey/dp/0385306849",
                    "size": [
                        214,
                        300
                    ]
                }
            ]
        },
        {
            "name": "Games",
            "title": "Games I love",
            "id": "games",
            "collection": [
                {
                    "title": "Super Mario Bros.",
                    "author": "Nintendo",
                    "year": 1985,
                    "url": "https://en.wikipedia.org/wiki/Super_Mario_Bros.",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Duck Hunt",
                    "author": "Nintendo",
                    "year": 1984,
                    "url": "https://en.wikipedia.org/wiki/Duck_Hunt",
                    "size": [
                        192,
                        300
                    ]
                },
                {
                    "title": "Soccer",
                    "author": "Nintendo",
                    "year": 1985,
                    "url": "https://en.wikipedia.org/wiki/Soccer_%281985_video_game%29",
                    "size": [
                        192,
                        300
                    ]
                },
                {
                    "title": "Galaga",
                    "author": "Namco",
                    "year": 1981,
                    "url": "https://en.wikipedia.org/wiki/Galaga",
                    "size": [
                        222,
                        300
                    ]
                },
                {
                    "title": "Nuts and Milk",
                    "author": "Hudson Soft",
                    "year": 1983,
                    "url": "https://en.wikipedia.org/wiki/Nuts_%26_Milk",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Crash Bandicoot",
                    "author": "Naughty Dog",
                    "year": 1996,
                    "url": "https://en.wikipedia.org/wiki/Crash_Bandicoot_(video_game)"
                },
                {
                    "title": "Crash Bandicoot: Warped",
                    "author": "Naughty Dog",
                    "year": 1998,
                    "url": "https://en.wikipedia.org/wiki/Crash_Bandicoot:_Warped"
                },
                {
                    "title": "Crash Team Racing",
                    "author": "Naughty Dog",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/Crash_Team_Racing"
                },
                {
                    "title": "Need for Speed: High Stakes",
                    "author": "Electronic Arts",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/Need_for_Speed%3A_High_Stakes"
                },
                {
                    "title": "Jackie Chan Stuntmaster",
                    "author": "Radical Entertainment",
                    "year": 2000,
                    "url": "https://en.wikipedia.org/wiki/Jackie_Chan_Stuntmaster"
                },
                {
                    "title": "Legacy of Kain: Soul Reaver",
                    "author": "Crystal Dynamics",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/Legacy_of_Kain%3A_Soul_Reaver"
                },
                {
                    "title": "Need for Speed: Porsche Unleashed",
                    "author": "Electronic Arts",
                    "year": 2000,
                    "url": "https://en.wikipedia.org/wiki/Need_for_Speed%3A_Porsche_Unleashed"
                },
                {
                    "title": "Rayman 2: The Great Escape",
                    "author": "Ubisoft",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/Rayman_2:_The_Great_Escape"
                },
                {
                    "title": "Star Wars: Episode I \u2013 The Phantom Menace",
                    "author": "Big Ape Productions",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/Star_Wars:_Episode_I_\u2013_The_Phantom_Menace_(video_game)"
                },
                {
                    "title": "Bugs Bunny: Lost in Time",
                    "author": "Behaviour Interactive",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/Bugs_Bunny%3A_Lost_in_Time"
                },
                {
                    "title": "Grand Theft Auto: Vice City Stories",
                    "author": "Rockstar Games",
                    "year": 2006,
                    "url": "https://en.wikipedia.org/wiki/Grand_Theft_Auto:_Vice_City_Stories",
                    "size": [
                        177,
                        300
                    ]
                },
                {
                    "title": "Gran Turismo",
                    "author": "Polyphony Digital",
                    "year": 2009,
                    "url": "https://en.wikipedia.org/wiki/Gran_Turismo_(2009_video_game)",
                    "size": [
                        177,
                        300
                    ]
                },
                {
                    "title": "Grand Theft Auto III",
                    "author": "DMA Design",
                    "year": 2001,
                    "url": "https://en.wikipedia.org/wiki/Grand_Theft_Auto_III",
                    "size": [
                        213,
                        300
                    ]
                },
                {
                    "title": "Grand Theft Auto: Vice City",
                    "author": "Rockstar North",
                    "year": 2002,
                    "url": "https://en.wikipedia.org/wiki/Grand_Theft_Auto%3A_Vice_City",
                    "size": [
                        200,
                        300
                    ]
                },
                {
                    "title": "Grand Theft Auto: San Andreas",
                    "author": "Rockstar North",
                    "year": 2004,
                    "url": "https://en.wikipedia.org/wiki/Grand_Theft_Auto:_San_Andreas",
                    "size": [
                        200,
                        300
                    ]
                },
                {
                    "title": "Grand Theft Auto IV",
                    "author": "Rockstar North",
                    "year": 2008,
                    "url": "https://en.wikipedia.org/wiki/Grand_Theft_Auto_IV",
                    "size": [
                        200,
                        300
                    ]
                },
                {
                    "title": "Grand Theft Auto V",
                    "author": "Rockstar North",
                    "year": 2013,
                    "url": "https://en.wikipedia.org/wiki/Grand_Theft_Auto_V",
                    "size": [
                        213,
                        300
                    ]
                },
                {
                    "title": "Doom",
                    "author": "id Software",
                    "year": 1993,
                    "url": "https://en.wikipedia.org/wiki/Doom_(1993_video_game)",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Quake II",
                    "author": "id Software",
                    "year": 1997,
                    "url": "https://en.wikipedia.org/wiki/Quake_II",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Quake III Arena",
                    "author": "id Software",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/Quake_III_Arena",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Doom 3",
                    "author": "id Software",
                    "year": 2004,
                    "url": "https://en.wikipedia.org/wiki/Doom_3",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Quake 4",
                    "author": "Raven Software",
                    "year": 2005,
                    "url": "https://en.wikipedia.org/wiki/Quake_4",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Half-Life",
                    "author": "Valve Software",
                    "year": 2005,
                    "url": "https://en.wikipedia.org/wiki/Half-Life_(video_game)",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Portal",
                    "author": "Valve Software",
                    "year": 2007,
                    "url": "https://en.wikipedia.org/wiki/Portal_(video_game)",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Portal 2",
                    "author": "Valve Software",
                    "year": 2011,
                    "url": "https://en.wikipedia.org/wiki/Portal_2",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "The Sims",
                    "author": "Maxis",
                    "year": 2000,
                    "url": "https://en.wikipedia.org/wiki/The_Sims_(video_game)",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "RollerCoaster Tycoon",
                    "author": "Chris Sawyer",
                    "year": 1999,
                    "url": "https://en.wikipedia.org/wiki/RollerCoaster_Tycoon_(video_game)",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "The Simpsons: Hit & Run",
                    "author": "Radical Entertainment",
                    "year": 2003,
                    "url": "https://en.wikipedia.org/wiki/The_Simpsons:_Hit_&_Run",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Halo: Combat Evolved",
                    "author": "Bungie",
                    "year": 2001,
                    "url": "https://en.wikipedia.org/wiki/Halo:_Combat_Evolved",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Halo: Reach",
                    "author": "Bungie",
                    "year": 2010,
                    "url": "https://en.wikipedia.org/wiki/Halo:_Reach",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Tetris",
                    "author": "Nintendo",
                    "year": 1989,
                    "url": "https://en.wikipedia.org/wiki/Tetris_%28Game_Boy_video_game%29"
                },
                {
                    "title": "Donkey Kong Country",
                    "author": "Rare",
                    "year": 1994,
                    "url": "https://en.wikipedia.org/wiki/Donkey_Kong_Country"
                },
                {
                    "title": "Conker\u2019s Pocket Tales",
                    "author": "Rare",
                    "year": 1994,
                    "url": "https://en.wikipedia.org/wiki/Conker%27s_Pocket_Tales"
                },
                {
                    "title": "Game & Watch Gallery 2",
                    "author": "Nintendo",
                    "year": 1997,
                    "url": "https://en.wikipedia.org/wiki/Game_%26_Watch_Gallery_2"
                },
                {
                    "title": "Tetris DX",
                    "author": "Nintendo",
                    "year": 1998,
                    "url": "https://tetris.wiki/Tetris_DX"
                },
                {
                    "title": "Pok\xe9mon LeafGreen",
                    "author": "Game Freak",
                    "year": 2004,
                    "url": "https://en.wikipedia.org/wiki/Pok\xe9mon_FireRed_and_LeafGreen"
                },
                {
                    "title": "Mario Kart: Super Circuit",
                    "author": "Nintendo",
                    "year": 2001,
                    "url": "https://en.wikipedia.org/wiki/Mario_Kart:_Super_Circuit"
                },
                {
                    "title": "The Legend of Zelda: The Minish Cap",
                    "author": "Nintendo",
                    "year": 2004,
                    "url": "https://en.wikipedia.org/wiki/The_Legend_of_Zelda%3A_The_Minish_Cap"
                },
                {
                    "title": "Tony Hawk\u2019s Pro Skater 2",
                    "author": "Neversoft",
                    "year": 2000,
                    "url": "https://en.wikipedia.org/wiki/Tony_Hawk's_Pro_Skater_2"
                },
                {
                    "title": "Luigi\u2019s Mansion",
                    "author": "Nintendo",
                    "year": 2001,
                    "url": "https://en.wikipedia.org/wiki/Mario_Kart:_Super_Circuit",
                    "size": [
                        213,
                        300
                    ]
                },
                {
                    "title": "Mario Kart 7",
                    "author": "Nintendo",
                    "year": 2011,
                    "url": "https://en.wikipedia.org/wiki/Mario_Kart_7",
                    "size": [
                        330,
                        300
                    ]
                },
                {
                    "title": "Luigi\u2019s Mansion: Dark Moon",
                    "author": "Nintendo",
                    "year": 2013,
                    "url": "https://en.wikipedia.org/wiki/Luigi%27s_Mansion:_Dark_Moon",
                    "size": [
                        330,
                        300
                    ]
                },
                {
                    "title": "Mario Kart 8",
                    "author": "Nintendo",
                    "year": 2014,
                    "url": "https://en.wikipedia.org/wiki/Mario_Kart_8",
                    "size": [
                        213,
                        300
                    ]
                },
                {
                    "title": "Captain Toad: Treasure Tracker",
                    "author": "Nintendo",
                    "year": 2014,
                    "url": "https://en.wikipedia.org/wiki/Captain_Toad%3A_Treasure_Tracker",
                    "size": [
                        213,
                        300
                    ]
                },
                {
                    "title": "Donkey Kong Country: Tropical Freeze",
                    "author": "Retro Studios",
                    "year": 2014,
                    "url": "https://en.wikipedia.org/wiki/Donkey_Kong_Country:_Tropical_Freeze",
                    "size": [
                        213,
                        300
                    ]
                },
                {
                    "title": "The Legend of Zelda: Breath of the Wild",
                    "author": "Nintendo",
                    "year": 2017,
                    "url": "https://en.wikipedia.org/wiki/The_Legend_of_Zelda:_Breath_of_the_Wild",
                    "size": [
                        213,
                        300
                    ]
                },
                {
                    "title": "Super Mario Odyssey",
                    "author": "Nintendo",
                    "year": 2017,
                    "url": "https://en.wikipedia.org/wiki/Super_Mario_Odyssey",
                    "size": [
                        183,
                        300
                    ]
                },
                {
                    "title": "Animal Crossing: New Horizons",
                    "author": "Nintendo",
                    "year": 2020,
                    "url": "https://en.wikipedia.org/wiki/Animal_Crossing:_New_Horizons",
                    "size": [
                        183,
                        300
                    ]
                },
                {
                    "title": "Luigi\u2019s Mansion 3",
                    "author": "Nintendo",
                    "year": 2019,
                    "url": "https://en.wikipedia.org/wiki/Luigi%27s_Mansion_3",
                    "size": [
                        183,
                        300
                    ]
                },
                {
                    "title": "The Legend of Zelda: Link\u2019s Awakening",
                    "author": "Nintendo",
                    "year": 2019,
                    "url": "https://en.wikipedia.org/wiki/The_Legend_of_Zelda:_Link%27s_Awakening_(2019_video_game)",
                    "size": [
                        183,
                        300
                    ]
                },
                {
                    "title": "Metroid Dread",
                    "author": "Nintendo",
                    "year": 2021,
                    "url": "https://en.wikipedia.org/wiki/Metroid_Dread",
                    "size": [
                        183,
                        300
                    ]
                },
                {
                    "title": "Machinarium",
                    "author": "Amanita Design",
                    "year": 2009,
                    "url": "https://en.wikipedia.org/wiki/Machinarium",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Minecraft",
                    "author": "Mojang Studios",
                    "year": 2009,
                    "url": "https://en.wikipedia.org/wiki/Minecraft",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Amnesia: The Dark Descent",
                    "author": "Frictional Games",
                    "year": 2010,
                    "url": "https://en.wikipedia.org/wiki/Amnesia:_The_Dark_Descent",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "The Stanley Parable",
                    "author": "Galactic Cafe",
                    "year": 2013,
                    "url": "https://en.wikipedia.org/wiki/The_Stanley_Parable",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "The Binding of Isaac: Rebirth",
                    "author": "Nicalis",
                    "year": 2014,
                    "url": "https://en.wikipedia.org/wiki/The_Binding_of_Isaac:_Rebirth",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Roundabout",
                    "author": "No Goblin",
                    "year": 2014,
                    "url": "https://en.wikipedia.org/wiki/Roundabout_(video_game)",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Undertale",
                    "author": "Toby Fox",
                    "year": 2015,
                    "url": "https://en.wikipedia.org/wiki/Undertale",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Firewatch",
                    "author": "Campo Santo",
                    "year": 2016,
                    "url": "https://en.wikipedia.org/wiki/Firewatch",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Untitled Goose Game",
                    "author": "House House",
                    "year": 2019,
                    "url": "https://en.wikipedia.org/wiki/Untitled_Goose_Game",
                    "size": [
                        198,
                        300
                    ]
                },
                {
                    "title": "Uninvited",
                    "author": "John Calhoun",
                    "year": 1986,
                    "url": "https://en.wikipedia.org/wiki/Uninvited_(video_game)",
                    "size": [
                        240,
                        300
                    ]
                },
                {
                    "title": "Glider",
                    "author": "John Calhoun",
                    "year": 1988,
                    "url": "https://en.wikipedia.org/wiki/Glider_(video_game)",
                    "size": [
                        240,
                        300
                    ]
                }
            ]
        }
    ]
};


function $01492f4bb51aadff$var$slugify(str) {
    str = str.replace(/^\s+|\s+$/g, ""); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, "") // remove any non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
    return str;
}
var $01492f4bb51aadff$export$2e2bcd8739ae039 = $01492f4bb51aadff$var$slugify;


const $45b4330bef09ce6c$var$convertedLinks = (0, (/*@__PURE__*/$parcel$interopDefault($ac4e782dc62cac3b$exports))).links.map((link)=>{
    const title = Object.keys(link)[0];
    const url = link[title];
    return {
        title: title,
        url: url
    };
});
const $45b4330bef09ce6c$var$convertedCollections = (0, (/*@__PURE__*/$parcel$interopDefault($ac4e782dc62cac3b$exports))).collections.map((collection)=>{
    const title = collection.name;
    const url = `/${(0, $01492f4bb51aadff$export$2e2bcd8739ae039)(title)}/`;
    return {
        title: title,
        url: url
    };
});
const $45b4330bef09ce6c$var$root = {
    destinations: [].concat($45b4330bef09ce6c$var$convertedLinks, $45b4330bef09ce6c$var$convertedCollections),
    ...(0, (/*@__PURE__*/$parcel$interopDefault($ac4e782dc62cac3b$exports)))
};
var $45b4330bef09ce6c$export$2e2bcd8739ae039 = $45b4330bef09ce6c$var$root;


class $4ce0e466a8b61f20$var$Preloader {
    async fonts() {
        const getCookie = function(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) return parts.pop().split(";").shift();
        };
        if (getCookie("fontsLoaded")) return;
        if ("fonts" in document) {
            await document.fonts.ready;
            const expires = new Date(+new Date() + 604800000).toUTCString();
            document.cookie = "fontsLoaded=true; expires=" + expires;
        }
    }
    async imagesContainedInElement(element) {
        const images = element.querySelectorAll("img");
        const promises = Array.from(images).map((img)=>{
            return new Promise((resolve, reject)=>{
                if (img.complete) // If the image is already loaded
                resolve();
                else {
                    // Add event listeners for load and error
                    img.addEventListener("load", resolve);
                    img.addEventListener("error", reject);
                }
            });
        });
        return await Promise.all(promises);
    }
}
var $4ce0e466a8b61f20$export$2e2bcd8739ae039 = $4ce0e466a8b61f20$var$Preloader;



const $d993782146de6f99$export$b283b9aead8739e7 = (title, collectionIdentifier)=>{
    const imagesForCollection = $22bfca6e648b3dd6$exports[collectionIdentifier];
    if (!imagesForCollection) {
        console.warn(`Unknown collection for collection "${collectionIdentifier}"`);
        return undefined;
    }
    const key = `${(0, $01492f4bb51aadff$export$2e2bcd8739ae039)(title)}.jpg`;
    const image = imagesForCollection[key];
    if (!image) {
        console.warn(`Unknown image for key "${key}"`);
        return undefined;
    }
    return image;
};


class $60f1e16227ca98ba$var$SpringboardApplianceCell extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.node.className = "cell";
        // Just adding this will enable :active on touch.
        this.node.addEventListener("touchstart", ()=>{});
    }
    configure(appliance, options) {
        const { didSelect: didSelect } = options;
        const identifier = `${appliance.title.toLowerCase()}.png`;
        const image = (0, $3c24900110178db7$exports)[identifier];
        this.node.onclick = didSelect;
        this.node.innerHTML = `
      <picture class="icon">
        <source srcset="${image}" type="image/png" />
        <img src="${image}" />
      </picture>
      <div class="label">${appliance.title}</div>
    `;
    }
}
var $60f1e16227ca98ba$export$2e2bcd8739ae039 = $60f1e16227ca98ba$var$SpringboardApplianceCell;



class $5084bc5d8b9995dd$var$PageControl extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    static indicatorClassName = "page-indicator";
    static selectedIndicatorClassName = "selected";
    constructor(){
        super();
        this._currentPage = 0;
        this._numberOfPages = 1;
        this._hidesForSinglePage = true;
        this.node.className = "page-control";
        this.configure();
    }
    configure() {
        const { numberOfPages: numberOfPages, currentPage: currentPage } = this;
        const indicators = [];
        for(let idx = 0; idx < numberOfPages; idx += 1){
            const indicator = document.createElement("div");
            indicator.className = $5084bc5d8b9995dd$var$PageControl.indicatorClassName;
            indicators.push(indicator);
        }
        const fragment = document.createDocumentFragment();
        indicators.forEach((indicator)=>fragment.appendChild(indicator));
        this.node.innerHTML = "";
        this.node.appendChild(fragment);
        this.node.style.visibility = this.hidesForSinglePage && numberOfPages == 1 ? "hidden" : "";
        this._indicators = indicators;
        this.selectionDidChange();
    }
    selectionDidChange() {
        const indicator = this._indicators[this.currentPage];
        if (!indicator) return;
        if (this._selectedIndicator) this._selectedIndicator.classList.remove($5084bc5d8b9995dd$var$PageControl.selectedIndicatorClassName);
        indicator.classList.add($5084bc5d8b9995dd$var$PageControl.selectedIndicatorClassName);
        this._selectedIndicator = indicator;
    }
    set hidesForSinglePage(flag) {
        if (flag != this._hidesForSinglePage) {
            this._hidesForSinglePage = flag;
            this.configure();
        }
    }
    get hidesForSinglePage() {
        return this._hidesForSinglePage;
    }
    set numberOfPages(number) {
        if (number != this._numberOfPages) {
            this._numberOfPages = number;
            this.configure();
        }
    }
    get numberOfPages() {
        return this._numberOfPages;
    }
    set currentPage(page) {
        if (page != this._currentPage) {
            this._currentPage = page;
            this.selectionDidChange();
        }
    }
    get currentPage() {
        return this._currentPage;
    }
}
var $5084bc5d8b9995dd$export$2e2bcd8739ae039 = $5084bc5d8b9995dd$var$PageControl;


class $1211a090d3f38ed0$var$SpringboardView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    static get animation() {
        return {
            in: "animate-in",
            out: "animate-out"
        };
    }
    constructor(appliances){
        super();
        this.appliances = appliances;
        this.node.className = "springboard-view";
        // Container:
        const containerView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        containerView.node.className = "springboard-container";
        containerView.node.addEventListener("scroll", this.containerDidScroll.bind(this));
        this.containerView = containerView;
        this.addSubview(containerView);
        // Page control:
        const pageControl = new (0, $5084bc5d8b9995dd$export$2e2bcd8739ae039)();
        this.pageControl = pageControl;
        this.addSubview(pageControl);
        // Configure:
        this.configure();
        // Re-layout on resize:
        window.addEventListener("resize", (event)=>this.configure());
        window.requestAnimationFrame(()=>this.configure());
    }
    configure() {
        const { appliances: appliances, containerView: containerView } = this;
        const layout = (0, $ace68b3a13623495$export$2e2bcd8739ae039).layout({
            itemCount: appliances.length,
            containerNode: containerView.node
        });
        if (this.layout && this.layout.isEquivalent(layout)) return;
        const { rows: rows, columns: columns } = layout;
        containerView.node.style.setProperty("--rows", rows);
        containerView.node.style.setProperty("--columns", columns);
        containerView.node.innerHTML = "";
        this.layout = layout;
        const appliancesPerPage = rows * columns;
        const pagesCount = Math.ceil(appliances.length / appliancesPerPage);
        for(let page = 0; page < pagesCount; page += 1){
            const offset = page * appliancesPerPage;
            const pageView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
            pageView.node.className = "page-container";
            appliances.slice(offset, offset + appliancesPerPage).forEach((appliance)=>{
                const cell = new (0, $60f1e16227ca98ba$export$2e2bcd8739ae039)();
                cell.configure(appliance, {
                    didSelect: (event)=>{
                        this.selectAppliance(appliance, cell, event);
                    }
                });
                pageView.addSubview(cell);
            });
            containerView.addSubview(pageView);
        }
        this.pageControl.numberOfPages = pagesCount;
    }
    // - Cell selection.
    selectAppliance(appliance, cell, event) {
        const { didSelectAppliance: didSelectAppliance } = this;
        if (didSelectAppliance) didSelectAppliance(appliance, event);
        if (cell) {
            const deselectSeconds = 0.35;
            const { classList: classList } = cell.node;
            classList.add("selected");
            setTimeout(()=>{
                classList.remove("selected");
            }, deselectSeconds * 1000);
        }
    }
    // - Scroll
    containerDidScroll() {
        const { pageControl: pageControl, containerView: containerView } = this;
        const { node: node } = containerView;
        const currentPage = Math.round(node.scrollLeft / node.getBoundingClientRect().width);
        pageControl.currentPage = currentPage;
    }
    // - Animations
    animate(animationName, options) {
        const { currentPage: currentPage } = this.pageControl;
        const pageContainer = this.node.querySelectorAll(".page-container")[currentPage];
        const icons = pageContainer.querySelectorAll(".cell");
        const auxiliary = [
            this.pageControl.node
        ];
        const pageContainerRect = pageContainer.getBoundingClientRect();
        const centerX = pageContainerRect.width / 2;
        const centerY = pageContainerRect.height / 2;
        const translationDistance = 300; // Distance to move the icons
        Array.from(icons).concat(auxiliary).forEach((icon)=>{
            const rect = icon.getBoundingClientRect();
            const iconX = rect.left + rect.width / 2;
            const iconY = rect.top + rect.height / 2;
            const dx = iconX - centerX;
            const dy = iconY - centerY;
            const length = Math.sqrt(dx * dx + dy * dy);
            const directionX = dx / length;
            const directionY = dy / length;
            const finalX = iconX + translationDistance * directionX;
            const finalY = iconY + translationDistance * directionY;
            const keyframes = [
                {
                    transform: new DOMMatrix()
                },
                {
                    transform: new DOMMatrix().translate(finalX - iconX, finalY - iconY)
                }
            ];
            if (animationName !== $1211a090d3f38ed0$var$SpringboardView.animation.out) keyframes.reverse();
            icon.animate(keyframes, options);
        });
    }
}
var $1211a090d3f38ed0$export$2e2bcd8739ae039 = $1211a090d3f38ed0$var$SpringboardView;


class $a23511e17ba6eb48$var$RootView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    springboardView;
    presentedView;
    static defaultAnimationOptions = {
        duration: 300,
        easing: "ease-in-out"
    };
    constructor(data){
        super();
        this.node.className = "root-view";
        this.data = data;
        // Springboard:
        const springboardView = new (0, $1211a090d3f38ed0$export$2e2bcd8739ae039)(data.destinations);
        springboardView.didSelectAppliance = (appliance)=>{
            this.notifyDidNavigate(appliance.url);
        };
        this.springboardView = springboardView;
        this.addSubview(springboardView);
        // Prepend header:
        const headerView = new (0, $14d50b1536b6b818$export$2e2bcd8739ae039)();
        springboardView.node.prepend(headerView.node);
        // Escape handler:
        document.addEventListener("keyup", (event)=>{
            if (event.key === "Escape") this.notifyDidNavigate("/");
        });
    }
    notifyDidNavigate(url) {
        const { didSelectURL: didSelectURL } = this;
        if (didSelectURL) didSelectURL(url);
    }
    present(view, { animated: animated = true } = options) {
        if (this.presentation) throw new Error("Attempted to present a view when already presenting");
        // Wrapper:
        const presentationWrapper = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        presentationWrapper.node.className = "presentation-wrapper";
        const spacerView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        spacerView.node.className = "spacer";
        presentationWrapper.addSubview(spacerView);
        presentationWrapper.addSubview(view);
        // Container that contains wrapper:
        const presentationContainer = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        presentationContainer.node.className = "presentation-container";
        presentationContainer.addSubview(presentationWrapper);
        this.addSubview(presentationContainer);
        this.presentation = {
            presentationWrapper: presentationWrapper,
            presentationContainer: presentationContainer
        };
        // Set up scroll:
        window.requestAnimationFrame(()=>{
            presentationWrapper.node.scrollLeft = presentationWrapper.node.getBoundingClientRect().width;
            presentationWrapper.node.addEventListener("scroll", (event)=>{
                const offset = presentationWrapper.node.scrollLeft;
                if (offset <= 1.0) {
                    presentationWrapper.node.scrollLeft = 0.0;
                    this.dismiss({
                        animated: false
                    });
                } else {
                    const { width: width } = presentationWrapper.node.getBoundingClientRect();
                }
            });
        });
        // Animate:
        const animate = ()=>{
            const options1 = $a23511e17ba6eb48$var$RootView.defaultAnimationOptions;
            presentationWrapper.node.animate([
                {
                    transform: new DOMMatrix().scale(0.25),
                    opacity: 0
                },
                {
                    transform: new DOMMatrix().scale(1)
                }
            ], options1);
            this.springboardView.animate((0, $1211a090d3f38ed0$export$2e2bcd8739ae039).animation.out, options1);
        };
        if (animated) window.requestAnimationFrame(animate);
    }
    dismiss({ animated: animated = true } = options) {
        if (!this.presentation) return;
        const { presentationContainer: presentationContainer, presentationWrapper: presentationWrapper } = this.presentation;
        this.presentation = undefined;
        const dismiss = ()=>{
            // Remove view:
            presentationContainer.removeFromSuperview();
            // Notify:
            this.notifyDidNavigate("/");
        };
        if (animated) {
            const options1 = $a23511e17ba6eb48$var$RootView.defaultAnimationOptions;
            const animation = presentationWrapper.node.animate([
                {
                    transform: new DOMMatrix().scale(1)
                },
                {
                    transform: new DOMMatrix().scale(0.25),
                    opacity: 0
                }
            ], options1);
            this.springboardView.animate((0, $1211a090d3f38ed0$export$2e2bcd8739ae039).animation.in, options1);
            animation.finished.then(dismiss);
        } else dismiss();
    }
    animateSpringboardIn() {
        const options1 = $a23511e17ba6eb48$var$RootView.defaultAnimationOptions;
        const fade = this.springboardView.node.animate([
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ], options1);
        this.springboardView.animate("animate-in", options1);
    }
}
var $a23511e17ba6eb48$export$2e2bcd8739ae039 = $a23511e17ba6eb48$var$RootView;





class $4521b753c8e2b278$var$LibraryNavigationBar extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    makeNode(document1) {
        return document1.createElement("header");
    }
    constructor(){
        super();
        const titleNode = document.createElement("span");
        titleNode.className = "title";
        this.titleNode = titleNode;
        this.node.appendChild(titleNode);
        const closeNode = document.createElement("button");
        closeNode.className = "close-button";
        closeNode.onclick = (event)=>{
            const { didSelectClose: didSelectClose } = this;
            if (didSelectClose) didSelectClose(event);
        };
        this.closeNode = closeNode;
        this.node.appendChild(closeNode);
    }
    set title(text) {
        this.titleNode.textContent = text;
    }
    get title() {
        return this.titleNode.textContent;
    }
}
var $4521b753c8e2b278$export$2e2bcd8739ae039 = $4521b753c8e2b278$var$LibraryNavigationBar;




class $89f2c919108c26ea$var$MarqueeLabel extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.node.className = "marquee-container";
        const wrapperNode = document.createElement("span");
        wrapperNode.className = "marquee-text-wrapper";
        this.wrapperNode = wrapperNode;
        this.node.appendChild(wrapperNode);
        this._text = "";
        this.textNodes = [];
        this.containerMetrics = {};
        this.configure();
        const invalidateLayout = ()=>{
            if (this.willLayout) return;
            this.willLayout = true;
            window.requestAnimationFrame(()=>{
                this._hasDirtyMetrics = true;
                this.layout();
                this.willLayout = false;
            });
        };
        window.addEventListener("resize", invalidateLayout);
        invalidateLayout();
    }
    layout() {
        const { node: node, textNodes: textNodes, containerMetrics: containerMetrics } = this;
        const firstNode = textNodes[0];
        const boundsForFirstNode = firstNode.getBoundingClientRect();
        const textWidth = Math.ceil(boundsForFirstNode.width);
        this._hasDirtyMetrics |= containerMetrics.parentWidth <= 0;
        if (this._hasDirtyMetrics) {
            const style = window.getComputedStyle(node);
            const metrics = {
                parentWidth: node.getBoundingClientRect().width,
                paddingLeft: parseFloat(style.paddingLeft),
                paddingRight: parseFloat(style.paddingRight),
                interSpacing: 32
            };
            Object.assign(containerMetrics, metrics);
            this._hasDirtyMetrics = false;
        }
        const { interSpacing: interSpacing, parentWidth: parentWidth, paddingLeft: paddingLeft, paddingRight: paddingRight } = containerMetrics;
        const availableWidth = parentWidth - paddingLeft - paddingRight;
        const marqueeRequired = textWidth > availableWidth;
        textNodes.forEach((node, index)=>{
            const visible = marqueeRequired || index == 0;
            node.style.visibility = !visible ? "hidden" : "";
        });
        const distance = textWidth + interSpacing;
        const centerLeftMargin = Math.floor((parentWidth - textWidth) / 2);
        // Apply center left margin to first node:
        firstNode.style.marginLeft = `${Math.max(centerLeftMargin - interSpacing, 0)}px`;
        if (marqueeRequired) {
            this.stop();
            const keyframes = [
                {
                    transform: new DOMMatrix()
                },
                {
                    transform: new DOMMatrix().translate(distance * -1, 0)
                }
            ];
            const speed = 80; // `px` per second
            const duration = distance / speed * 1000;
            const options = {
                easing: "linear",
                duration: duration
            };
            const delayForStart = 1000;
            const delayForRepeat = 5000;
            const animate = ()=>{
                const animation = this.wrapperNode.animate(keyframes, options);
                animation.onfinish = ()=>{
                    this.scheduledAnimate = setTimeout(animate, delayForRepeat);
                };
                this.animation = animation;
            };
            this.scheduledAnimate = setTimeout(animate, delayForStart);
        } else this.stop();
    }
    stop() {
        if (this.animation) {
            this.animation.cancel();
            this.animation = undefined;
        }
        if (this.scheduledAnimate) window.clearTimeout(this.scheduledAnimate);
    }
    configure() {
        const requiredTextNodeCount = 2;
        if (this.textNodes.length != requiredTextNodeCount) {
            const textNodes = [];
            const fragment = document.createDocumentFragment();
            for(let idx = 0; idx < requiredTextNodeCount; idx += 1){
                const textNode = document.createElement("span");
                textNode.className = "marquee-repeating";
                textNodes.push(textNode);
                fragment.appendChild(textNode);
            }
            this.wrapperNode.innerHTML = "";
            this.wrapperNode.appendChild(fragment);
            this.textNodes = textNodes;
        }
        const { text: text, textNodes: textNodes } = this;
        textNodes.forEach((node)=>node.textContent = text);
    }
    set text(text) {
        if (!text) text = "";
        if (text !== this.text) {
            this._text = text;
            this.stop();
            this.configure();
            this.layout();
        }
    }
    get text() {
        return this._text;
    }
}
var $89f2c919108c26ea$export$2e2bcd8739ae039 = $89f2c919108c26ea$var$MarqueeLabel;


class $5a1c5d10ecc56cad$var$LibraryItemDetailView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.node.className = "detail";
        // Title:
        const titleNode = document.createElement("span");
        titleNode.className = "title";
        const titleMarquee = new (0, $89f2c919108c26ea$export$2e2bcd8739ae039)();
        titleNode.appendChild(titleMarquee.node);
        this.titleNode = titleNode;
        this.titleMarquee = titleMarquee;
        this.node.appendChild(titleNode);
        // Author:
        const authorNode = document.createElement("span");
        authorNode.className = "author";
        this.authorNode = authorNode;
        this.node.appendChild(authorNode);
        // Year:
        const yearNode = document.createElement("span");
        yearNode.className = "year";
        this.yearNode = yearNode;
        this.node.appendChild(yearNode);
    }
    configure(configuration, { animated: animated = true } = options) {
        const { title: title, author: author, year: year, url: url } = configuration;
        this.titleMarquee.text = title;
        this.authorNode.textContent = author;
        this.yearNode.textContent = year;
    }
}
var $5a1c5d10ecc56cad$export$2e2bcd8739ae039 = $5a1c5d10ecc56cad$var$LibraryItemDetailView;



class $0abdec52b1bbd628$var$LibraryItemCell extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    static get style() {
        return {
            music: "music"
        };
    }
    constructor(){
        super();
        this.node.className = "cell";
    }
    configure(configuration, options) {
        const { image: image, style: style, size: size } = configuration;
        this.src = image;
        this.style = style;
        this.node.innerHTML = `<div class="image"></div>`;
        if (size) {
            const [width, height] = size;
            this.node.style.width = `${width}px`;
            this.node.style.height = `${height}px`;
        }
        const { didSelect: didSelect } = options;
        this.node.onclick = didSelect;
        this.node.classList.add("loading");
    }
    didAppear() {
        const { src: src, style: style } = this;
        const pictureMarkup = `
      <picture class="image">
        <source type="image/jpeg" srcset="${src}" />
        <img src="${src}" />
      </picture>
    `;
        this.node.innerHTML = pictureMarkup;
        if (style === $0abdec52b1bbd628$var$LibraryItemCell.style.music) {
            const reflectionNode = document.createElement("span");
            reflectionNode.className = "reflection";
            reflectionNode.innerHTML = pictureMarkup;
            this.node.appendChild(reflectionNode);
        }
        const didLoad = ()=>{
            this.node.classList.remove("loading");
        };
        const img = this.node.querySelector("img");
        img.onload = didLoad;
    }
    didDisappear() {
        this.node.innerHTML = "";
    }
}
var $0abdec52b1bbd628$export$2e2bcd8739ae039 = $0abdec52b1bbd628$var$LibraryItemCell;



class $1a7a37cb9d4471a2$var$LibraryCollectionView extends (0, $75862b29e2b1753f$export$2e2bcd8739ae039) {
    constructor(data){
        super();
        this.data = data;
        this.node.className = "library-collection-view";
        this.node.classList.add(data.id);
        // Navigation:
        const navigationBar = new (0, $4521b753c8e2b278$export$2e2bcd8739ae039)();
        navigationBar.title = data.title;
        this.navigationBar = navigationBar;
        this.addSubview(navigationBar);
        // Grid:
        const collectionWrapperView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        collectionWrapperView.node.className = "collection-wrapper";
        const collectionContainerView = new (0, $75862b29e2b1753f$export$2e2bcd8739ae039)();
        collectionContainerView.node.className = "collection-container";
        collectionWrapperView.addSubview(collectionContainerView);
        this.cells = data.collection.map((item, idx)=>{
            const cell = new (0, $0abdec52b1bbd628$export$2e2bcd8739ae039)();
            cell.configure({
                image: (0, $d993782146de6f99$export$b283b9aead8739e7)(item.title, data.id),
                style: data.id,
                size: item.size
            }, {
                didSelect: (event)=>{
                    this.didSelectItem(idx);
                }
            });
            collectionContainerView.addSubview(cell);
            return cell;
        });
        this.collectionWrapperView = collectionWrapperView;
        this.collectionContainerView = collectionContainerView;
        this.addSubview(collectionWrapperView);
        // First, last:
        const setReferenceWidthForPropertyNamed = (item, prop)=>{
            const { size: size } = item;
            if (size) {
                const [width] = size;
                collectionWrapperView.node.style.setProperty(prop, `${width}px`);
            }
        };
        setReferenceWidthForPropertyNamed(data.collection[0], "--first-item-width");
        setReferenceWidthForPropertyNamed(data.collection.slice(-1)[0], "--last-item-width");
        // Detail:
        const itemDetailView = new (0, $5a1c5d10ecc56cad$export$2e2bcd8739ae039)();
        this.itemDetailView = itemDetailView;
        this.addSubview(itemDetailView);
        // Handle scroll:
        const handleScroll = ()=>{
            this.invalidate();
        };
        collectionContainerView.node.addEventListener("scroll", $1a7a37cb9d4471a2$var$throttle(handleScroll, 250));
        this.invalidate();
    }
    invalidate() {
        const frame = ()=>{
            this.configure();
            this.request = undefined;
        };
        if (this.request) return;
        this.request = window.requestAnimationFrame(frame);
    }
    configure() {
        const wrapper = this.collectionWrapperView.node;
        const wrapperRect = (0, $cba996667aa58736$export$c79fc6492f3af13d).fromDOMRect(wrapper.getBoundingClientRect());
        const wrapperCenterX = wrapperRect.midX;
        let closestIndex = 0;
        let closestDistance = Number.MAX_VALUE;
        const visibilityInset = wrapperRect.width * -1;
        const visibilityRect = wrapperRect.insetBy(visibilityInset, 0);
        visibilityRect.origin.y = -Infinity;
        visibilityRect.size.height = Infinity;
        this.cells.forEach((cell, idx)=>{
            const itemRect = (0, $cba996667aa58736$export$c79fc6492f3af13d).fromDOMRect(cell.node.getBoundingClientRect());
            const distance = Math.abs(itemRect.midX - wrapperCenterX);
            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = idx;
            }
            const isVisible = visibilityRect.intersects(itemRect);
            if (isVisible != !!cell.isVisible) {
                cell.isVisible = isVisible;
                if (isVisible) cell.didAppear();
                else cell.didDisappear();
            }
        });
        if (this.focusedIndex !== closestIndex) {
            const item = this.data.collection[closestIndex];
            if (item) this.itemDetailView.configure(item, {
                animated: false
            });
            this.focusedItemIndex = closestIndex;
        }
    }
    didSelectItem(idx) {
        if (idx == this.focusedItemIndex) this.openInformationAtIndex(idx);
        else this.scrollToItemAtIndex(idx);
    }
    openInformationAtIndex(idx) {
        const item = this.data.collection[idx];
        window.app.handleURL(item.url, {
            animated: true
        });
    }
    scrollToItemAtIndex(idx) {
        const node = this.cells[idx].node;
        node.scrollIntoView({
            behavior: "smooth",
            inline: "center"
        });
    }
}
function $1a7a37cb9d4471a2$var$throttle(callbackFn, limit) {
    let wait = false;
    return function() {
        if (!wait) {
            callbackFn.call();
            wait = true;
            setTimeout(function() {
                wait = false;
            }, limit);
        }
    };
}
var $1a7a37cb9d4471a2$export$2e2bcd8739ae039 = $1a7a37cb9d4471a2$var$LibraryCollectionView;



class $35da740d59af89ba$var$Directory extends (0, $1553bf3484a166d1$export$2e2bcd8739ae039) {
    documentDidLoad() {
        // Configure root:
        const root = new (0, $a23511e17ba6eb48$export$2e2bcd8739ae039)({
            destinations: (0, $45b4330bef09ce6c$export$2e2bcd8739ae039).destinations
        });
        root.didSelectURL = (url)=>{
            this.handleURL(url, {
                animated: true
            });
        };
        const containerNode = document.body;
        containerNode.style.visibility = "hidden";
        containerNode.appendChild(root.node);
        this.rootView = root;
        // Configure preloader:
        const preloader = new (0, $4ce0e466a8b61f20$export$2e2bcd8739ae039)();
        const prepare = async ()=>{
            try {
                const fonts = preloader.fonts();
                const springboardIcons = preloader.imagesContainedInElement(root.springboardView.node);
                await Promise.all([
                    fonts,
                    springboardIcons
                ]);
            } catch (error) {
                console.warn("An error was encountered when preloading", error);
            }
            window.requestAnimationFrame(()=>{
                containerNode.style.visibility = "";
                root.animateSpringboardIn();
            });
        };
        prepare();
        // Resolve path:
        const path = window.location.pathname;
        if (path !== "/") this.handleURL(path, {
            animated: false
        });
    }
    handleURL(url, { animated: animated = false } = options) {
        let urlObj;
        try {
            urlObj = new URL(url, window.location.origin);
        } catch (e) {
            console.error("Invalid URL:", e);
            return;
        }
        // Handle external URLs:
        if (urlObj.host !== window.location.host) {
            this.openURL(url);
            return;
        }
        // Handle path:
        const { pathname: pathname } = urlObj;
        // Root:
        if (pathname === "/") {
            this.rootView.dismiss({
                animated: animated
            });
            history.replaceState({
                path: url
            }, (0, $45b4330bef09ce6c$export$2e2bcd8739ae039).title, url);
            document.title = (0, $45b4330bef09ce6c$export$2e2bcd8739ae039).title;
            this.setPrefersLightTheme(false, {
                animated: animated
            });
        } else if (pathname.startsWith("/")) {
            const normalizedPathname = pathname.replace(/\/+$/, "");
            const collection = (0, $45b4330bef09ce6c$export$2e2bcd8739ae039).collections.filter((item)=>`/${item.name.toLowerCase()}` === normalizedPathname)[0];
            if (collection) {
                const view = new (0, $1a7a37cb9d4471a2$export$2e2bcd8739ae039)(collection);
                view.navigationBar.didSelectClose = ()=>{
                    this.handleURL("/", {
                        animated: true
                    });
                };
                if (collection["prefers-light-theme"]) this.setPrefersLightTheme(true, {
                    animated: animated
                });
                this.rootView.present(view, {
                    animated: animated
                });
                history.replaceState({
                    path: url
                }, collection.title, url);
                document.title = `${collection.title} \u{2014}\xa0${(0, $45b4330bef09ce6c$export$2e2bcd8739ae039).title}`;
            } else // TODO: 404
            this.handleURL("/", {
                animated: animated
            });
        } else console.warn("Ignored URL", url);
    }
    openURL(url) {
        // Note: window.open() sucks, this works better:
        const a = document.createElement("a");
        a.style.position = "fixed";
        a.target = "_blank";
        a.href = url;
        const containerNode = document.body;
        containerNode.appendChild(a);
        a.click();
        containerNode.removeChild(a);
    }
    setPrefersLightTheme(prefersLightTheme, { animated: animated } = options) {
        const name = [
            "--theme-color",
            "--theme-color-light"
        ][prefersLightTheme | 0];
        const themeColor = window.getComputedStyle(document.documentElement).getPropertyValue(name);
        if (animated) {
            const options1 = (0, $a23511e17ba6eb48$export$2e2bcd8739ae039).defaultAnimationOptions;
            const animation = document.body.animate([
                {
                    backgroundColor: themeColor
                }
            ], options1);
            const completion = ()=>{
                document.body.style.backgroundColor = themeColor;
            };
            animation.finished.then(completion);
        } else document.body.style.backgroundColor = themeColor;
    }
}
window.app = new $35da740d59af89ba$var$Directory(document);


//# sourceMappingURL=index.286028ac.js.map
